webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoContent_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cee60ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoContent_vue__ = __webpack_require__(183);
function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cee60ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cee60ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoButton_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0081e68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoButton_vue__ = __webpack_require__(184);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0081e68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoList_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4b46aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoList_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4b46aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoListItem_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_291dbc38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoListItem_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_291dbc38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-valparaiso.f842ff2.svg";

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoTwoColSection_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a251e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoTwoColSection_vue__ = __webpack_require__(192);
function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27a251e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoTwoColSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a251e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoTwoColSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoSplash_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34cf0a0d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoSplash_vue__ = __webpack_require__(216);
function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34cf0a0d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoSplash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34cf0a0d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoSplash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image-beach.cca1153.jpg";

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(140);




var config = {
  site: {
    name: "Adventures of the Valparaiso",
    version: 2.0,
    mode: 1 // 0: under construction, 1: online/normal
  },
  data: {
    preserve: 3, // days till data is expired
    loadtime: 1500 // ms to show loader regardless of cache status
  },
  api: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */],
  firebase: __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* default */]
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  created: function created() {
    this.$_config = config;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoYoutubeSplash_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569edcfb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoYoutubeSplash_vue__ = __webpack_require__(181);
function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-569edcfb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoYoutubeSplash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569edcfb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoYoutubeSplash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoTopBar__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoFooter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoPartners__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie_law__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie_law___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie_law__);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Site",
  components: { ValpoFooter: __WEBPACK_IMPORTED_MODULE_1__components_ValpoFooter__["a" /* default */], ValpoTopBar: __WEBPACK_IMPORTED_MODULE_0__components_ValpoTopBar__["a" /* default */], ValpoPartners: __WEBPACK_IMPORTED_MODULE_2__components_ValpoPartners__["a" /* default */], CookieLaw: __WEBPACK_IMPORTED_MODULE_3_vue_cookie_law___default.a }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoSocialmedia__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoMainNav__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoLogo__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TopBar",
  components: {
    ValpoSocialmedia: __WEBPACK_IMPORTED_MODULE_0__components_ValpoSocialmedia__["a" /* default */],
    ValpoMainNav: __WEBPACK_IMPORTED_MODULE_1__components_ValpoMainNav__["a" /* default */],
    ValpoLogo: __WEBPACK_IMPORTED_MODULE_2__components_ValpoLogo__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoSocialmedia_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f2401a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoSocialmedia_vue__ = __webpack_require__(113);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14f2401a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoSocialmedia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f2401a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoSocialmedia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoListItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_icons_fb_blck_svg__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_icons_fb_blck_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_icons_fb_blck_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_icons_instagram_svg__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_icons_instagram_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_icons_instagram_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_icons_mail_svg__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_icons_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_icons_mail_svg__);
//
//
//
//
//
//
//
//
//
//
//
//


// Components



// Images

// import twitter from "../assets/images/icons/twitter.svg";
// import youtube from "../assets/images/icons/youtube.svg";



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Socialmedia",
  components: {
    ValpoList: __WEBPACK_IMPORTED_MODULE_0__components_ValpoList__["a" /* default */],
    ValpoListItem: __WEBPACK_IMPORTED_MODULE_1__components_ValpoListItem__["a" /* default */]
  },
  data: function data() {
    return {
      socialicons: [{
        icon: __WEBPACK_IMPORTED_MODULE_2__assets_images_icons_fb_blck_svg___default.a,
        alt: "Facebook"
      },
      // {
      //   icon: twitter,
      //   alt: "Twitter"
      // },
      // {
      //   icon: youtube,
      //   alt: "Youtube"
      // },
      {
        icon: __WEBPACK_IMPORTED_MODULE_3__assets_images_icons_instagram_svg___default.a,
        alt: "Instagram"
        // ,
        // {
        //   icon: email,
        //   alt: "Contact"
        // }
      }]
    };
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "List"
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ListItem"
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoLogo__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MainNavigation",
  components: {
    ValpoLogo: __WEBPACK_IMPORTED_MODULE_1__components_ValpoLogo__["a" /* default */]
  },
  data: function data() {
    return {
      images: [__WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg___default.a],
      menuItems: ["Index", "About", "Npe", "Volunteer", "Partnership", "Events", "Contact"],
      menuIsActive: false
    };
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoLogo_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd5f4e9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoLogo_vue__ = __webpack_require__(116);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd5f4e9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Logo",
  props: {
    color: {
      type: String,
      required: false,
      default: "#fff"
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoSocialmedia__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Footer",
  components: { ValpoSocialmedia: __WEBPACK_IMPORTED_MODULE_1__components_ValpoSocialmedia__["a" /* default */] },
  data: function data() {
    return {
      images: { logo: __WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg___default.a },
      thisYear: new Date().getFullYear()
    };
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoPartners_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03025d4a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoPartners_vue__ = __webpack_require__(133);
function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03025d4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoPartners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03025d4a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoPartners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_partners_53gradennoord_jpg__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_partners_53gradennoord_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_partners_53gradennoord_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_partners_Azart_partners_png__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_partners_Azart_partners_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_partners_Azart_partners_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_partners_elektro_producten_partners_png__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_partners_elektro_producten_partners_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_partners_elektro_producten_partners_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_partners_glas_in_lood_boot_partners_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_partners_glas_in_lood_boot_partners_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_partners_glas_in_lood_boot_partners_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_partners_horeca_partners_png__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_partners_horeca_partners_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_partners_horeca_partners_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_partners_leds4life_partners_png__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_partners_leds4life_partners_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_partners_leds4life_partners_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_partners_zeeds_partners_png__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_partners_zeeds_partners_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_partners_zeeds_partners_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_partners_erasmusplus_png__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_partners_erasmusplus_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_partners_erasmusplus_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_partners_european_commission_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_partners_european_commission_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_partners_european_commission_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_partners_tastebefore_jpg__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_partners_tastebefore_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_partners_tastebefore_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ValpoList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ValpoListItem__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Partners",
  components: { ValpoList: __WEBPACK_IMPORTED_MODULE_10__components_ValpoList__["a" /* default */], ValpoListItem: __WEBPACK_IMPORTED_MODULE_11__components_ValpoListItem__["a" /* default */] },
  data: function data() {
    return {
      images: {
        north53: __WEBPACK_IMPORTED_MODULE_0__assets_images_partners_53gradennoord_jpg___default.a,
        azart: __WEBPACK_IMPORTED_MODULE_1__assets_images_partners_Azart_partners_png___default.a,
        elektro: __WEBPACK_IMPORTED_MODULE_2__assets_images_partners_elektro_producten_partners_png___default.a,
        glas: __WEBPACK_IMPORTED_MODULE_3__assets_images_partners_glas_in_lood_boot_partners_png___default.a,
        horeca: __WEBPACK_IMPORTED_MODULE_4__assets_images_partners_horeca_partners_png___default.a,
        leds4life: __WEBPACK_IMPORTED_MODULE_5__assets_images_partners_leds4life_partners_png___default.a,
        zeeds: __WEBPACK_IMPORTED_MODULE_6__assets_images_partners_zeeds_partners_png___default.a,
        erasmusplus: __WEBPACK_IMPORTED_MODULE_7__assets_images_partners_erasmusplus_png___default.a,
        eurocommission: __WEBPACK_IMPORTED_MODULE_8__assets_images_partners_european_commission_png___default.a,
        tastebefore: __WEBPACK_IMPORTED_MODULE_9__assets_images_partners_tastebefore_jpg___default.a
      },
      ourPartners: [{
        icon: __WEBPACK_IMPORTED_MODULE_0__assets_images_partners_53gradennoord_jpg___default.a,
        alt: "53 Nord"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_1__assets_images_partners_Azart_partners_png___default.a,
        alt: "Azart"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_2__assets_images_partners_elektro_producten_partners_png___default.a,
        alt: "Elektro Producten"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3__assets_images_partners_glas_in_lood_boot_partners_png___default.a,
        alt: "Glas in Loot Boot"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_9__assets_images_partners_tastebefore_jpg___default.a,
        alt: "Taste Before You Waste"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_5__assets_images_partners_leds4life_partners_png___default.a,
        alt: "Leds 4 Life"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_6__assets_images_partners_zeeds_partners_png___default.a,
        alt: "Zeedruk"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_7__assets_images_partners_erasmusplus_png___default.a,
        alt: "Erasmus+"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_8__assets_images_partners_european_commission_png___default.a,
        alt: "European Commission"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4__assets_images_partners_horeca_partners_png___default.a,
        alt: "Horeka"
      }]
    };
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoYoutubeSplash__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValpoList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ValpoListItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ValpoEvents__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ValpoTwoColSection__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ValpoPartners__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logo_valparaiso_svg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logo_valparaiso_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_logo_valparaiso_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_headers_ship_water_jpg__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_headers_ship_water_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_headers_ship_water_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_graphic_boat_jpg__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_graphic_boat_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_graphic_boat_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_image_hand_jpg__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_image_hand_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_image_hand_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_icons_big_pirate_icon_svg__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_icons_big_pirate_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_icons_big_pirate_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_icon_connect_svg__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_icon_connect_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_icon_connect_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_icon_globe_svg__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_icon_globe_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_icon_globe_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_icons_speaker_icon_svg__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_icons_speaker_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_icons_speaker_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_icons_treasure_icon_svg__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_icons_treasure_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_icons_treasure_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_icons_wrench_icon_svg__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_icons_wrench_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_icons_wrench_icon_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Index",
  components: {
    ValpoYoutubeSplash: __WEBPACK_IMPORTED_MODULE_0__components_ValpoYoutubeSplash__["a" /* default */],
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoButton: __WEBPACK_IMPORTED_MODULE_2__components_ValpoButton__["a" /* default */],
    ValpoList: __WEBPACK_IMPORTED_MODULE_3__components_ValpoList__["a" /* default */],
    ValpoListItem: __WEBPACK_IMPORTED_MODULE_4__components_ValpoListItem__["a" /* default */],
    ValpoEvents: __WEBPACK_IMPORTED_MODULE_5__components_ValpoEvents__["a" /* default */],
    ValpoTwoColSection: __WEBPACK_IMPORTED_MODULE_6__components_ValpoTwoColSection__["a" /* default */],
    ValpoPartners: __WEBPACK_IMPORTED_MODULE_7__components_ValpoPartners__["a" /* default */]
  },
  data: function data() {
    return {
      images: { logo: __WEBPACK_IMPORTED_MODULE_8__assets_images_logo_valparaiso_svg___default.a, ship: __WEBPACK_IMPORTED_MODULE_9__assets_images_headers_ship_water_jpg___default.a, boat: __WEBPACK_IMPORTED_MODULE_10__assets_images_graphic_boat_jpg___default.a, hand: __WEBPACK_IMPORTED_MODULE_11__assets_images_image_hand_jpg___default.a },
      video: {
        src: "r4Zm6H12WbM"
      },
      involved: [{
        icon: __WEBPACK_IMPORTED_MODULE_12__assets_images_icons_big_pirate_icon_svg___default.a,
        alt: "Become a Volunteer",
        link: "Volunteer"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_13__assets_images_icon_connect_svg___default.a,
        alt: "Become our Partners",
        link: "Partnership"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_14__assets_images_icon_globe_svg___default.a,
        alt: "Experience the Community",
        link: "Services"
      }],
      pirateStuff: [{
        icon: __WEBPACK_IMPORTED_MODULE_15__assets_images_icons_speaker_icon_svg___default.a,
        alt: "Stories"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_16__assets_images_icons_treasure_icon_svg___default.a,
        alt: "Goods"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_17__assets_images_icons_wrench_icon_svg___default.a,
        alt: "Skills"
      }]
    };
  }
  // mounted () {
  //     this.pagedata = JSON.parse(localStorage.getItem('valparaiso'))[this.$options.name.toLowerCase()]
  // }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "YoutubeSplash",
  data: function data() {
    return {
      playerVars: {
        frameborder: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        rel: 0,
        showinfo: 0
      },
      windowsWidth: window.innerWidth,
      windowsHeight: window.innerHeight,
      isPlaying: false
    };
  },
  props: {
    video: {
      type: Object,
      required: true
    },
    image: {
      type: String,
      required: false,
      default: ""
    }
  },
  components: {},
  computed: {
    player: function player() {
      return this.$refs.youtube.player;
    }
  },
  methods: {
    playVideo: function playVideo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.player.playVideo();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    playing: function playing() {
      // Hide Title when Playing
      this.isPlaying = true;
    },
    paused: function paused() {
      this.isPlaying = false;
      console.log("Paaaused");
    },
    ended: function ended() {
      this.isPlaying = false;
    }
  }
});

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Content"
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Button",
  props: {
    url: {
      type: String,
      required: false,
      default: ""
    },
    label: {
      type: String,
      required: false,
      default: ""
    },
    target: {
      type: String,
      required: false,
      default: ""
    }
  },
  methods: {},
  computed: {
    doBounce: function doBounce() {
      this.$_anime({
        targets: '.bounce',
        translateY: '50vh',
        duration: 300,
        loop: false,
        direction: 'alternate',
        easing: 'easeInCubic',
        scaleX: {
          value: 1.05,
          duration: 150,
          delay: 268
        }
      });
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoFbEvents__ = __webpack_require__(187);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ValpoButton from "@/components/ValpoButton";


// import event01 from "../assets/images/image-event01.jpg";
// import event02 from "../assets/images/image-event02.jpg";
// import event03 from "../assets/images/image-event03.jpg";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Events",
  components: {
    // ValpoButton,
    ValpoFbEvents: __WEBPACK_IMPORTED_MODULE_0__components_ValpoFbEvents__["a" /* default */]
  },
  data: function data() {
    return {
      events: [{
        title: "First-aid Empathy",
        date: "November 1, 2017",
        type: "workshop",
        image: event01,
        body: "A lot of people struggle giving support when a friend is in pain, most would try to comfort their friend by giving advice or telling something about an experience they themselves once had. Advice, sympathy, pity and many more ways we choose to comfort our loved ones are not always the best way to bring comfort to our friends and help them mourn.",
        url: "https://www.facebook.com/events/1424126381016071"
      }, {
        title: "Delicious dumpster dinner",
        date: "November 3, 2017",
        type: "dinner",
        image: event02,
        body: "Let's have a lovely dinner at our lovely boat. Just an evening where we come together and celebrate our community.",
        url: "https://www.facebook.com/events/1315747708551348"
      }, {
        title: "Captain's Maritime",
        date: "November 17, 2017",
        type: "event",
        image: event03,
        body: "The Captain invites you to come on board in Amsterdam Noord for chiling out, food, talks & inspiration. You'll get to know our project and share ideas to keep creating a collaborative, sustainable and happy community.",
        url: "https://www.facebook.com/events/1085736448229563"
      }]
    };
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FbEvents"
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TwoColSection"
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoYoutubeSplash__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_image_giuliana_jpg__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_image_giuliana_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_image_giuliana_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_image_beach_jpg__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_image_beach_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_image_beach_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_icon_building_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_icon_building_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_icon_building_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_icon_design_svg__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_icon_design_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_icon_design_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_icon_video_svg__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_icon_video_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_icon_video_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_icon_marketing_svg__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_icon_marketing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_icon_marketing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_icon_social_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_icon_social_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_icon_social_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_projects_image_light_jpg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_projects_image_light_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_projects_image_light_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_projects_image_qr_jpg__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_projects_image_qr_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_projects_image_qr_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_projects_image_birds_jpg__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_projects_image_birds_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_projects_image_birds_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_projects_valparaiso_projects_boatbike_jpg__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_projects_valparaiso_projects_boatbike_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_projects_valparaiso_projects_boatbike_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_projects_valparaiso_projects_festivals_jpg__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_projects_valparaiso_projects_festivals_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_projects_valparaiso_projects_festivals_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_projects_valparaiso_projects_glass_jpg__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_projects_valparaiso_projects_glass_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_projects_valparaiso_projects_glass_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_projects_valparaiso_projects_grulla_jpg__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_projects_valparaiso_projects_grulla_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_projects_valparaiso_projects_grulla_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























// TODO: add new pictures

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Volunteer",
  components: {
    ValpoYoutubeSplash: __WEBPACK_IMPORTED_MODULE_0__components_ValpoYoutubeSplash__["a" /* default */],
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoList: __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__["a" /* default */],
    ValpoListItem: __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__["a" /* default */],
    ValpoButton: __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__["a" /* default */]
  },
  data: function data() {
    return {
      images: { giuliana: __WEBPACK_IMPORTED_MODULE_5__assets_images_image_giuliana_jpg___default.a, beach: __WEBPACK_IMPORTED_MODULE_6__assets_images_image_beach_jpg___default.a },
      video: {
        src: "cjC9ggS7EVE"
      },
      tasks: [{
        icon: __WEBPACK_IMPORTED_MODULE_7__assets_images_icon_building_svg___default.a,
        alt: "Building & Repairing"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_8__assets_images_icon_design_svg___default.a,
        alt: "Design"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_9__assets_images_icon_video_svg___default.a,
        alt: "Multimedia Production"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_10__assets_images_icon_marketing_svg___default.a,
        alt: "Marketing"
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_11__assets_images_icon_social_svg___default.a,
        alt: "Social Media"
      }],
      projects: [{
        image: __WEBPACK_IMPORTED_MODULE_12__assets_images_projects_image_light_jpg___default.a,
        title: "Ship upgrading",
        description: "Grab the tools and get hands on!"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_13__assets_images_projects_image_qr_jpg___default.a,
        title: "The Pirate App",
        description: "Code with our pirate developers"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_15__assets_images_projects_valparaiso_projects_boatbike_jpg___default.a,
        title: "Boat-Bike",
        description: "Building a pirate ship on an e-bike"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_16__assets_images_projects_valparaiso_projects_festivals_jpg___default.a,
        title: "Festival planning",
        description: "Organize summer festivals!"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_17__assets_images_projects_valparaiso_projects_glass_jpg___default.a,
        title: "Stained glass",
        description: "An old craft in a new light"
      }]
    };
  }
});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image-giuliana.ef6b875.jpg";

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ValpoTwoColSection__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ValpoTimeline__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_about_jpg__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_about_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_headers_about_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_image_beach_jpg__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_image_beach_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_image_beach_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_icons_pirate_economy_svg__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_icons_pirate_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_icons_pirate_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_crew_valparaiso_crew_ulysses_jpg__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_crew_valparaiso_crew_ulysses_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_crew_valparaiso_crew_ulysses_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_crew_dan_jpg__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_crew_dan_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_crew_dan_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_crew_valparaiso_crew_dave_jpg__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_crew_valparaiso_crew_dave_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_crew_valparaiso_crew_dave_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_crew_valparaiso_crew_lyvia_jpg__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_crew_valparaiso_crew_lyvia_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_crew_valparaiso_crew_lyvia_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_crew_valparaiso_crew_jennie_jpg__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_crew_valparaiso_crew_jennie_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_crew_valparaiso_crew_jennie_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_crew_oksanka_jpg__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_crew_oksanka_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_crew_oksanka_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_crew_veronika_jpg__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_crew_veronika_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_crew_veronika_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_crew_Ramiro_Ramirez_crew_jpg__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_crew_Ramiro_Ramirez_crew_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_crew_Ramiro_Ramirez_crew_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// Images



// import light from "../assets/images/image-light.jpg";
// import qr from "../assets/images/image-qr.jpg";
// import birds from "../assets/images/image-birds.jpg";



// Crew









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "About",
  components: {
    ValpoSplash: __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__["a" /* default */],
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoList: __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__["a" /* default */],
    ValpoListItem: __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__["a" /* default */],
    ValpoButton: __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__["a" /* default */],
    ValpoTwoColSection: __WEBPACK_IMPORTED_MODULE_5__components_ValpoTwoColSection__["a" /* default */],
    ValpoTimeline: __WEBPACK_IMPORTED_MODULE_6__components_ValpoTimeline__["a" /* default */]
  },
  data: function data() {
    return {
      images: {
        about: __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_about_jpg___default.a, beach: __WEBPACK_IMPORTED_MODULE_8__assets_images_image_beach_jpg___default.a
      },
      crew: [{
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_crew_valparaiso_crew_ulysses_jpg___default.a,
        name: "Ulysses Schuitemaker",
        title: "Captain - Founder - Youth Leader - European Co-ordinator"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_11__assets_images_crew_dan_jpg___default.a,
        name: "Dan Gibbon-Walsh",
        title: "Marketing - Communications - Strategy - Branding"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_14__assets_images_crew_valparaiso_crew_jennie_jpg___default.a,
        name: "Jennie Hughes",
        title: "Treasurer"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_15__assets_images_crew_oksanka_jpg___default.a,
        name: "Oksanka Tykhovska",
        title: "Youth Trainer - European Project Manager"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_12__assets_images_crew_valparaiso_crew_dave_jpg___default.a,
        name: "Dave Dega",
        title: "App Developer"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_16__assets_images_crew_veronika_jpg___default.a,
        name: "Veronika Hozjan",
        title: "Graphic Designer"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_13__assets_images_crew_valparaiso_crew_lyvia_jpg___default.a,
        name: "Lyvia Lozano",
        title: "South American Co-ordinator"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_17__assets_images_crew_Ramiro_Ramirez_crew_jpg___default.a,
        name: "Ramiro Ramirez",
        title: "Software Developer"
      }]
    };
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Splash",
  props: {
    video: {
      type: Object,
      required: false
    },
    image: {
      type: String,
      required: false,
      default: ""
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_timeline_birth_valparaiso_jpg__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_timeline_birth_valparaiso_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_timeline_birth_valparaiso_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_timeline_building_jpg__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_timeline_building_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_timeline_building_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_timeline_moving_to_amsterdam_jpg__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_timeline_moving_to_amsterdam_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_timeline_moving_to_amsterdam_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_timeline_colaborations2_jpg__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_timeline_colaborations2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_timeline_colaborations2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_timeline_festivals_jpg__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_timeline_festivals_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_timeline_festivals_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_timeline_making_the_plan_jpg__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_timeline_making_the_plan_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_timeline_making_the_plan_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_timeline_help_us_find_a_boat_jpg__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_timeline_help_us_find_a_boat_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_timeline_help_us_find_a_boat_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_timeline_freedom_festival_jpg__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_timeline_freedom_festival_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_timeline_freedom_festival_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_timeline_france_jpg__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_timeline_france_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_timeline_france_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_timeline_pirate_economy_trade_jpg__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_timeline_pirate_economy_trade_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_timeline_pirate_economy_trade_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_timeline_new_bote_jpg__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_timeline_new_bote_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_timeline_new_bote_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_timeline_pirate_app_jpg__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_timeline_pirate_app_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_timeline_pirate_app_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_timeline_trainings_1_jpg__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_timeline_trainings_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_timeline_trainings_1_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Images














/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ValpoTimeline",
  // components: {},
  data: function data() {
    return {
      items: [{
        day: "23 of May",
        year: "2012",
        title: "Birth",
        description: "The ship is found and the adventure begins! The 100 year old canal vessel and the nomadic Dutchman make their first journey towards their new life, with little idea of how many faces, stories, experiences and lessons they will encounter in their first exhilarating years together.",
        image: __WEBPACK_IMPORTED_MODULE_0__assets_images_timeline_birth_valparaiso_jpg___default.a
      }, {
        day: "23 of Jan",
        year: "2013",
        title: "Building",
        description: "While transforming the boat into a stained glass art studio, the Captain welcomes volunteers from a global community of artists, travellers and tradesmen. The adventurous souls sharing their skills and creativity onboard quickly become an essential part of the Valparaíso story.",
        image: __WEBPACK_IMPORTED_MODULE_1__assets_images_timeline_building_jpg___default.a
      }, {
        day: "10 of Dec",
        year: "2013",
        title: "Moving to Amsterdam",
        description: "It is time to broaden the Valparaíso horizons and she sets sail for Amsterdam! Here the Captain finds significantly more opportunities for creative collaborations, access to resources and an ever-widening circle of volunteers and kindred projects. An exciting new chapter begins!",
        image: __WEBPACK_IMPORTED_MODULE_2__assets_images_timeline_moving_to_amsterdam_jpg___default.a
      }, {
        day: "15 of Jul",
        year: "2014",
        title: "Collaboration",
        description: "The boat becomes a hub where artists meet to combine resources, abilities and ideas toward a vital creative life source, ART! The now-established onboard culture endorses the belief that creativity is essential to our happiness and survival, both as individuals and as a global family.",
        image: __WEBPACK_IMPORTED_MODULE_3__assets_images_timeline_colaborations2_jpg___default.a
      }, {
        day: "12 of Ago",
        year: "2015",
        title: "Festivals",
        description: "Summer! Deck and doors are thrown open and creativity and stories are used to form inviting bridges into several waterside festival communities. These are wildly successful events and many land and boat participants join in celebrating the Valparaíso culture.",
        image: __WEBPACK_IMPORTED_MODULE_4__assets_images_timeline_festivals_jpg___default.a
      }, {
        day: "6 of Nov",
        year: "2015",
        title: "Making the Plan",
        description: "Brainstorming and discussions have been churning away for awhile and now there is definite and increasing momentum in the Valparaíso currents. With expanding skill and vision, Captain and community earnestly prepare to (officially) launch the next grand adventure!",
        image: __WEBPACK_IMPORTED_MODULE_5__assets_images_timeline_making_the_plan_jpg___default.a
      }, {
        day: "26 of Feb",
        year: "2016",
        title: "Help us find a boat!",
        description: "Do you believe that this progressive culture can create mutually rewarding connections, that this ship can be a place where sustainability and art unite and that you can be a part of this destination? Share it on facebook , ask family and friends. spread the word",
        image: __WEBPACK_IMPORTED_MODULE_6__assets_images_timeline_help_us_find_a_boat_jpg___default.a
      }, {
        day: "5 of May",
        year: "2016",
        title: "Freedom Festival",
        description: "We where invited at various festivals to display our concept and show the onboard art. One of them was Vrijland where freedom was celebrated. Checkout the video at 2:17",
        image: __WEBPACK_IMPORTED_MODULE_7__assets_images_timeline_freedom_festival_jpg___default.a
      }, {
        day: "13 of Jul",
        year: "2016",
        title: "Brest Maritima",
        description: "We stepped on the shore and went to France to explain our concept. Also we showed on the fly how stained glass is being made.",
        image: __WEBPACK_IMPORTED_MODULE_8__assets_images_timeline_france_jpg___default.a
      }, {
        day: "9 of Sep",
        year: "2016",
        title: "New Pirate Economy!",
        description: "We kicked off our New Pirate Economy for the first time on the shore! Not on the water anymore but we made a trade-tent where people could trade goods against stories.Also we rented out friends that could help people that lost their friends or their keys! For free of course ;)",
        image: __WEBPACK_IMPORTED_MODULE_9__assets_images_timeline_pirate_economy_trade_jpg___default.a
      }, {
        day: "March",
        year: "2018",
        title: "Started the development of the Pirate App",
        description: "To be delivered by 2020, the aim is to connect people through goods, stories and skills, and show that everything has more worth than just money. We are looking for programmers, copywriters, funders and ambassadors to help deliver our goal, so get in touch if you want to be part of this exciting international work and shape the future of the New Pirate Economy.",
        image: __WEBPACK_IMPORTED_MODULE_11__assets_images_timeline_pirate_app_jpg___default.a
      }, {
        day: "Sep",
        year: "2018",
        title: "Began delivering Youth Exchanges",
        description: "In response to the growing youth unemployment rates across Europe, and the need to create new skills to equip younger generations with the future skills we need, Adventures of the Valparaiso is now delivering Youth Exchanges. We work with youth workers and young adults to help give them skills in a relaxed setting that they cannot otherwise access. To deliver trainings, become a youth exchange partner, or to find out more, email trainings@adventuresofthevalparaiso.com",
        image: __WEBPACK_IMPORTED_MODULE_12__assets_images_timeline_trainings_1_jpg___default.a
      }, {
        day: "Sep",
        year: "2021",
        title: "First Journey with the New Boat",
        description: "The sails will be unfurled and the course set! Exact date unknown.",
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_timeline_new_bote_jpg___default.a
      }]
    };
  }
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/trainings_1.fa15b0e.jpg";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pirate_economy.6980254.svg";

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ValpoTwoColSection__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_valparaiso_svg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_valparaiso_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_logo_valparaiso_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_npe_jpg__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_npe_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_headers_npe_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_headers_ship_jpg__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_headers_ship_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_headers_ship_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_icons_pirate_economy_svg__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_icons_pirate_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_icons_pirate_economy_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Npe",
  components: {
    ValpoSplash: __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__["a" /* default */],
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoList: __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__["a" /* default */],
    ValpoListItem: __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__["a" /* default */],
    ValpoButton: __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__["a" /* default */],
    ValpoTwoColSection: __WEBPACK_IMPORTED_MODULE_5__components_ValpoTwoColSection__["a" /* default */]
  },
  data: function data() {
    return {
      images: { logo: __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_valparaiso_svg___default.a, npe: __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_npe_jpg___default.a, iconEconomy: __WEBPACK_IMPORTED_MODULE_9__assets_images_icons_pirate_economy_svg___default.a, ship: __WEBPACK_IMPORTED_MODULE_8__assets_images_headers_ship_jpg___default.a }
    };
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ValpoTwoColSection__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_valparaiso_svg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_valparaiso_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_logo_valparaiso_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_partnership_jpg__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_partnership_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_headers_partnership_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_icon_building_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_icon_building_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_icon_building_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_icon_design_svg__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_icon_design_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_icon_design_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_icon_video_svg__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_icon_video_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_icon_video_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_icon_marketing_svg__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_icon_marketing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_icon_marketing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_icon_social_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_icon_social_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_icon_social_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Partnership",
  components: {
    ValpoSplash: __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__["a" /* default */],
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoList: __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__["a" /* default */],
    ValpoListItem: __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__["a" /* default */],
    ValpoButton: __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__["a" /* default */],
    ValpoTwoColSection: __WEBPACK_IMPORTED_MODULE_5__components_ValpoTwoColSection__["a" /* default */]
  },
  data: function data() {
    return {
      images: { logo: __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_valparaiso_svg___default.a, partnership: __WEBPACK_IMPORTED_MODULE_7__assets_images_headers_partnership_jpg___default.a }
    };
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoContactForm__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_image_beach_jpg__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_image_beach_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_image_beach_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Contact",
  components: {
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoContactForm: __WEBPACK_IMPORTED_MODULE_2__components_ValpoContactForm__["a" /* default */]
  },
  data: function data() {
    return {
      images: { beach: __WEBPACK_IMPORTED_MODULE_3__assets_images_image_beach_jpg___default.a }
    };
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoRecaptcha__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.initializeApp({
  apiKey: "AIzaSyAxobPYZVHkG1TfpkENA1KoZLtm9m_uews",
  authDomain: "valparaiso-b2287.firebaseapp.com",
  databaseURL: "https://valparaiso-b2287.firebaseio.com",
  projectId: "valparaiso-b2287",
  storageBucket: "valparaiso-b2287.appspot.com",
  messagingSenderId: "630564716917"
});

var addMessage = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.functions().httpsCallable('sendMessage');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "contactForm",
  components: { ValpoButton: __WEBPACK_IMPORTED_MODULE_0__components_ValpoButton__["a" /* default */], ValpoRecaptcha: __WEBPACK_IMPORTED_MODULE_1__components_ValpoRecaptcha__["a" /* default */] },
  data: function data() {
    return {
      contactName: '',
      contactEmail: '',
      contactSubject: '',
      contactMessage: '',
      contactHumanCheck: ''
    };
  },
  props: {},
  computed: {
    contactIsHuman: function contactIsHuman() {
      return parseInt(this.contactHumanCheck, 10) === 9;
    },
    emailDestination: function emailDestination() {
      switch (this.contactSubject) {
        case 'Volunteer Opportunities':
          return 'crew@adventuresofthevalparaiso.com';
          break;
        case 'Partnership Opportunities':
          return 'ulysses@adventuresofthevalparaiso.com';
          break;
        default:
          return 'marketing@adventuresofthevalparaiso.com';
      }
    }
  },
  methods: {
    processForm: function processForm() {
      if (this.contactIsHuman) {
        var messageData = {
          name: this.contactName,
          email: this.contactEmail,
          subject: this.contactSubject,
          destination: this.emailDestination,
          message: this.contactMessage
        };
        addMessage(messageData).then(function (result) {
          // Check if message was sent successfully and show confirmatino message
          console.log(result);
        });
      }
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__(256);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */] },
  data: function data() {
    return {
      sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: function onVerify(response) {
      console.log('Verify: ' + response);
    },
    onExpired: function onExpired() {
      console.log('Expired');
    },
    resetRecaptcha: function resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    }
  }
});

/***/ }),
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValpoTwoColSection__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Error",
  components: {
    ValpoSplash: __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__["a" /* default */],
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoButton: __WEBPACK_IMPORTED_MODULE_2__components_ValpoButton__["a" /* default */],
    ValpoTwoColSection: __WEBPACK_IMPORTED_MODULE_3__components_ValpoTwoColSection__["a" /* default */]
  },
  data: function data() {
    return {
      images: { logo: logo, giuliana: giuliana, beach: beach },
      video: {
        src: "https://fat.gfycat.com/HighlevelZestyAxolotl.webm",
        loop: true
      }
    };
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Construction",
  data: function data() {
    return {
      images: { logo: __WEBPACK_IMPORTED_MODULE_0__assets_images_logo_valparaiso_svg___default.a }
    };
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoYoutubeSplash__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ValpoTwoColSection__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_image_giuliana_jpg__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_image_giuliana_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_image_giuliana_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_image_beach_jpg__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_image_beach_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_image_beach_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_services_ship_02_jpg__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_services_ship_02_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_services_ship_02_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_services_tipi_jpg__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_services_tipi_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_services_tipi_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_services_festival01_jpg__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_services_festival01_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_services_festival01_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_services_festival02_jpg__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_services_festival02_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_services_festival02_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_services_festival03_jpg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_services_festival03_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_services_festival03_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_services_festival05_jpg__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_services_festival05_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_services_festival05_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_services_festival06_jpg__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_services_festival06_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_services_festival06_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_services_concept_rent_friend_jpg__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_services_concept_rent_friend_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_services_concept_rent_friend_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_services_concept_cranes_jpg__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_services_concept_cranes_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_services_concept_cranes_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_services_concept_glow_dark_jpg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_services_concept_glow_dark_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_services_concept_glow_dark_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_services_concept_dj_jpg__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_services_concept_dj_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_services_concept_dj_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_services_concept_mermaid_jpg__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_services_concept_mermaid_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_services_concept_mermaid_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Images















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Volunteer",
  components: {
    ValpoYoutubeSplash: __WEBPACK_IMPORTED_MODULE_0__components_ValpoYoutubeSplash__["a" /* default */],
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoList: __WEBPACK_IMPORTED_MODULE_2__components_ValpoList__["a" /* default */],
    ValpoListItem: __WEBPACK_IMPORTED_MODULE_3__components_ValpoListItem__["a" /* default */],
    ValpoButton: __WEBPACK_IMPORTED_MODULE_4__components_ValpoButton__["a" /* default */],
    ValpoTwoColSection: __WEBPACK_IMPORTED_MODULE_5__components_ValpoTwoColSection__["a" /* default */]
  },
  data: function data() {
    return {
      images: {
        giuliana: __WEBPACK_IMPORTED_MODULE_6__assets_images_image_giuliana_jpg___default.a,
        beach: __WEBPACK_IMPORTED_MODULE_7__assets_images_image_beach_jpg___default.a,
        ship: __WEBPACK_IMPORTED_MODULE_8__assets_images_services_ship_02_jpg___default.a,
        tipi: __WEBPACK_IMPORTED_MODULE_9__assets_images_services_tipi_jpg___default.a,
        gardensBabylon: __WEBPACK_IMPORTED_MODULE_10__assets_images_services_festival01_jpg___default.a,
        vrijland: __WEBPACK_IMPORTED_MODULE_11__assets_images_services_festival02_jpg___default.a,
        ceuvel: __WEBPACK_IMPORTED_MODULE_12__assets_images_services_festival03_jpg___default.a,
        intoTheWoods: __WEBPACK_IMPORTED_MODULE_13__assets_images_services_festival05_jpg___default.a,
        brestMaritime: __WEBPACK_IMPORTED_MODULE_14__assets_images_services_festival06_jpg___default.a,
        conceptRentFriend: __WEBPACK_IMPORTED_MODULE_15__assets_images_services_concept_rent_friend_jpg___default.a,
        conceptOrigamiCrane: __WEBPACK_IMPORTED_MODULE_16__assets_images_services_concept_cranes_jpg___default.a,
        conceptGlowDark: __WEBPACK_IMPORTED_MODULE_17__assets_images_services_concept_glow_dark_jpg___default.a,
        conceptDj: __WEBPACK_IMPORTED_MODULE_18__assets_images_services_concept_dj_jpg___default.a,
        conceptMermaid: __WEBPACK_IMPORTED_MODULE_19__assets_images_services_concept_mermaid_jpg___default.a
      },
      video: {
        src: "sv4tGRtvovY"
      },
      projects: [{
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_services_festival01_jpg___default.a,
        title: "Gardens of Babylon",
        description: ""
      }, {
        image: __WEBPACK_IMPORTED_MODULE_11__assets_images_services_festival02_jpg___default.a,
        title: "Vrijland",
        description: ""
      }, {
        image: __WEBPACK_IMPORTED_MODULE_12__assets_images_services_festival03_jpg___default.a,
        title: "Ceuvel",
        description: ""
      }, {
        image: __WEBPACK_IMPORTED_MODULE_13__assets_images_services_festival05_jpg___default.a,
        title: "Into the woods",
        description: ""
      }, {
        image: __WEBPACK_IMPORTED_MODULE_14__assets_images_services_festival06_jpg___default.a,
        title: "Brest Maritime",
        description: ""
      }],
      spaces: [{
        image: __WEBPACK_IMPORTED_MODULE_8__assets_images_services_ship_02_jpg___default.a,
        title: "The Valparaiso",
        description: "Deck and doors are thrown open. Visitors are welcomed in and invited to create their own place in the history of this 100-year old boat. We are a floating world of magic, a Fata Morgana on the water. The top deck is a lounge draped with blankets and pillows, and the ships also hosts a DJ booth and small stage. This wildly-popular venue can be reached by small boat or by swimming. It is usually moored in Amsterdam, as the hub of our creative community, but with a crane it can be put on long-distance transport."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_9__assets_images_services_tipi_jpg___default.a,
        title: "Tipi Tent",
        description: "The tipi is an inspiring place to relax. This eight metre space can host up to forty-five people, and includes a DJ deck and small stage. It is home to a beautiful mobile of origami cranes, is lit by UV lights, and is perfect for both relaxing and partying. But the experience we create is about more than the lights and Persian carpets. We invite people to step inside and become part of this world of imagination we build together."
      }],
      concepts: [{
        image: __WEBPACK_IMPORTED_MODULE_15__assets_images_services_concept_rent_friend_jpg___default.a,
        title: "Rent a Friend",
        description: "Ever lost a friend at a festival? It happens to all of us. Now you don’t have to be alone - you can rent a friend! If you need help finding your lost friends, or your lost keys, or you just don’t want to go to a dance alone, we have lots of friends in stock that you can rent for free! They come equipped with an alarm clock, and return automatically when it goes off! Our visitors are also invited to put themselves up to rent. Festivals are amazing places to meet people, and what better way to make new friends?",
        collaborator: "",
        link: ""
      }, {
        image: __WEBPACK_IMPORTED_MODULE_16__assets_images_services_concept_cranes_jpg___default.a,
        title: "Origami Crane Installation",
        description: "Visitors to Suzanne’s art studio are often asked to paint a piece of paper, which she then transforms into origami cranes. Over the years this had grown into a substantial flock of unique, hand-painted birds that radiate with the various souls that have contributed to it. This year, we are asking visitors to join in, painting their own pieces of paper to become part of this art installation and centrepiece that represents the beautiful things we can achieve through connection and community.",
        collaborator: "Suzanne Dirne",
        link: "http://overratedenzo.nl/"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_17__assets_images_services_concept_glow_dark_jpg___default.a,
        title: "Glow in the Dark Dating",
        description: "Ever tried dating in the dark? With our quizmaster deciding the rhythm of the night, all extra lights are off and all the glow in the dark makeup is on. Inspiring luminous connections in unique spaces under the romance of black lighting, it will make a great ‘how we met’ story in years to come. People will choose coloured bands to wear based on their dating preferences – purple for women, blue for men, and white for non-binary people. If they have no preferences, they can wear all three!",
        collaborator: "",
        link: ""
      }, {
        image: __WEBPACK_IMPORTED_MODULE_18__assets_images_services_concept_dj_jpg___default.a,
        title: "Music by Kevin Valentine",
        description: "Our DJ stage is a platform for emerging artists and hidden gems. We select our DJs carefully and make sure the music fits the vibe of the festival and our space. Depending on the program the DJ will play down tempo music or music that it will make it impossible for you to stand still! The intimate atmosphere makes sure this secret stage will be something all visitors will remember. Our doors are always open to new opportunities, new connections, and new experiences. Kevin also invites other unfamiliar DJs connected to the genre to play, so for this contact him on Soundcloud.",
        collaborator: "Kevin Valentine",
        link: "http://www.soundcloud.com/kevinvalentine"
      }, {
        image: __WEBPACK_IMPORTED_MODULE_19__assets_images_services_concept_mermaid_jpg___default.a,
        title: "Mobile Mermaid",
        description: "Normal mermaids don’t do too well out of water. They just flop around and flap their fins, and you have to come to see them. But the mermaid that the pirates captured is on wheels! She is an oracle who listens to the whispers of the wind and the waves, knows the stories of the sky and the sea - and the secrets of legless modes of travel. She drives around the festival, going from stage to stage. Who better than a mythical mermaid to bring a sense of calm and normality to this crazy world?",
        collaborator: "Veerle Nanna",
        link: "http://www.VnannaV.nl/"
      }]
    };
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoContent__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PrivacyPolicy",
  components: {
    ValpoContent: __WEBPACK_IMPORTED_MODULE_0__components_ValpoContent__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ValpoButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ValpoTwoColSection__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logo_valparaiso_svg__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logo_valparaiso_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_logo_valparaiso_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_timeline_trainings_1_jpg__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_timeline_trainings_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_timeline_trainings_1_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Npe",
  components: {
    ValpoSplash: __WEBPACK_IMPORTED_MODULE_0__components_ValpoSplash__["a" /* default */],
    ValpoContent: __WEBPACK_IMPORTED_MODULE_1__components_ValpoContent__["a" /* default */],
    ValpoButton: __WEBPACK_IMPORTED_MODULE_2__components_ValpoButton__["a" /* default */],
    ValpoTwoColSection: __WEBPACK_IMPORTED_MODULE_3__components_ValpoTwoColSection__["a" /* default */]
  },
  data: function data() {
    return {
      images: { logo: __WEBPACK_IMPORTED_MODULE_4__assets_images_logo_valparaiso_svg___default.a, trainings: __WEBPACK_IMPORTED_MODULE_5__assets_images_timeline_trainings_1_jpg___default.a }
    };
  }
});

/***/ }),
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_youtube__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_youtube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_youtube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(28);




// import store from './store'
// import { sync } from 'vuex-router-sync'







// sync(store, router)

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_youtube___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#site",
  name: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].site.name,
  // store,
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03724d6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(135);
function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03724d6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoTopBar_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5f9600_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoTopBar_vue__ = __webpack_require__(118);
function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoTopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5f9600_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoTopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"valpo-list"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"valpo-list-item"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC40OCAyMC40OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fS5jbHMtMiwuY2xzLTN7ZmlsbDojMWQxZDFkO30uY2xzLTN7c3Ryb2tlOiNmZmY7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5tYWlsPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSI+PGcgaWQ9Il9Hcm91cF8iIGRhdGEtbmFtZT0iJmx0O0dyb3VwJmd0OyI+PGNpcmNsZSBpZD0iX1BhdGhfIiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgY2xhc3M9ImNscy0xIiBjeD0iMTAuMjQiIGN5PSIxMC4yNCIgcj0iMTAuMjQiLz48cGF0aCBpZD0iX1BhdGhfMiIgZGF0YS1uYW1lPSImbHQ7UGF0aCZndDsiIGNsYXNzPSJjbHMtMSIgZD0iTTIwLjQzLDExLjI5LDE1Ljc2LDYuNjJsLTUuNTgsMi44LTUuNCw0LjUsNi41LDYuNUExMC4yNCwxMC4yNCwwLDAsMCwyMC40MywxMS4yOVoiLz48cGF0aCBpZD0iX1BhdGhfMyIgZGF0YS1uYW1lPSImbHQ7UGF0aCZndDsiIGNsYXNzPSJjbHMtMiIgZD0iTTE1LDE0LjIySDUuNDRhLjg4Ljg4LDAsMCwxLS44OC0uODhWNy4xNGEuODguODgsMCwwLDEsLjg4LS44OEgxNWEuODguODgsMCwwLDEsLjg4Ljg4djYuMTlBLjg4Ljg4LDAsMCwxLDE1LDE0LjIyWiIvPjxwYXRoIGlkPSJfUGF0aF80IiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgY2xhc3M9ImNscy0yIiBkPSJNMTUsNi4yNkgxMC4yNXY4SDE1YS44OC44OCwwLDAsMCwuODgtLjg4VjcuMTRBLjg4Ljg4LDAsMCwwLDE1LDYuMjZaIi8+PHBhdGggaWQ9Il9QYXRoXzUiIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBjbGFzcz0iY2xzLTMiIGQ9Ik0xMC4yNCwxMC44MSwxNS45Myw3LjRWNy4xNEEuODguODgsMCwwLDAsMTUsNi4yNkg1LjQ0YS44OC44OCwwLDAsMC0uODguODhWNy40WiIvPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"socialmedia",attrs:{"id":"socialmedia"}},[_c('valpo-list',{staticClass:"icons flex-center"},_vm._l((_vm.socialicons),function(item){return _c('valpo-list-item',{key:item.icon},[_c('router-link',{attrs:{"to":{ name: item.alt, params: {} }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.icon),expression:"item.icon"}],attrs:{"alt":item.alt}})])],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoMainNav_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9634a122_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoMainNav_vue__ = __webpack_require__(117);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoMainNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9634a122_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoMainNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 246.54 69.6"}},[_c('g',{attrs:{"data-name":"<Group>"}},[_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M96.14,69.6c.2-.31.33-.75.62-.9a1.81,1.81,0,0,0,1-1.85c0-2.8,0-5.61,0-8.41s0-5.61,0-8.41c0-1.12-.07-2.1-1.34-2.5-.09,0-.14-.2-.25-.36.55-.71,1.4-.29,2.05-.59a13,13,0,0,1,2.1-.57l.1,2a22.19,22.19,0,0,0,3.22-1.13c2.23-1.19,5.23.11,6.45,2.21a8.29,8.29,0,0,1,.45,7.67,4.46,4.46,0,0,1-2.91,2.65c-1.21.36-2.37.86-3.54,1.33a3.4,3.4,0,0,1-2.66.2,4,4,0,0,0-1.06-.08c0,.73,0,1.41,0,2.1,0,1.27,0,2.54,0,3.81a1.75,1.75,0,0,0,1,1.95c.43.19.45.48.36.85Zm4.19-20.7c0,3.08,0,6,0,8.86a1.43,1.43,0,0,0,.38,1c1.27.93,2.64,1.57,4.25.78a4.86,4.86,0,0,1,1-.37,2.5,2.5,0,0,0,1.64-1.4,7.65,7.65,0,0,0,.09-7.16A4.35,4.35,0,0,0,103,48.05,18.89,18.89,0,0,0,100.34,48.9Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M246.54,32.26A37.41,37.41,0,0,0,243,33.53a3.58,3.58,0,0,1-3.45,0c-1-.54-2.15-.91-3.39-1.42a7.08,7.08,0,0,1,.69-.41c1.16-.49,2.33-1,3.49-1.46a2.2,2.2,0,0,1,1.85,0c1.44.6,2.89,1.16,4.34,1.74Zm-7.11-.83h3.67C241.28,30.45,241.28,30.45,239.42,31.43Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M194.67,30.52c1,0,2.09-.06,3.14,0,.74,0,1.47.14,2.21.17,3.58.13,7.17.22,10.75.36,3.88.15,7.76.33,11.65.49l7.6.3a8.2,8.2,0,0,1,1.12.23c-.29.15-.35.21-.42.21l-7.73.28-8.65.29c-2,.07-3.93.17-5.89.25l-13.23.54-12.3.51L176,34.4l-11.78.51c-2.53.1-5.07.17-7.6.29-3.05.14-6.1.27-9.15.5a1.85,1.85,0,0,1-2.07-1.16,13.4,13.4,0,0,0-1.12-1.77,1.1,1.1,0,0,1,0-1.43A21.83,21.83,0,0,0,145.74,29a1.16,1.16,0,0,1,1.29-.64c1.13.09,2.26.14,3.4.2a43.33,43.33,0,0,1,5.49.31c1.82.33,3.62,0,5.42.19.81.1,1.63.19,2.44.27a3.26,3.26,0,0,0,.92,0c1.87-.36,3.73.12,5.6.08v.46c-2.08-.08-4.17-.17-6.25-.24l-10.6-.31-.39,0c-2-.08-4-.18-6-.23a1.22,1.22,0,0,0-.88.4A21.17,21.17,0,0,0,145,31.42H200.4v-.16l-5.67-.34Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M89.57,28.89l8.38-.33c.52,0,1-.11,1.56-.17a1.15,1.15,0,0,1,1.25.5c.64,1,1.32,2,2,3.11l-2.35,3.69c-3.08-.16-6.12-.34-9.17-.47-1.66-.07-3.33,0-5-.11-4.32-.16-8.64-.35-13-.53l-6.54-.27L54,33.8l-6.15-.25L41,33.26l-6-.25-13.35-.54L17,32.24a5.91,5.91,0,0,1-.76-.19,4.18,4.18,0,0,1,.77-.29c.35,0,.7,0,1.05,0,3.19-.1,6.38-.19,9.57-.3,2-.07,3.92-.17,5.89-.25,2.58-.1,5.15-.18,7.73-.29l10.46-.46v.48l-5.93.36v.11h55.78l-1.41-2.31h-.89l-10,.28Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M83.7,22H80.56c-1.06,0-1.06,0-1.31-1.24a26.33,26.33,0,0,0-2.66,1c-3.61,1.73-7-.45-7.91-3.92a7.94,7.94,0,0,1,.62-6.2,4.74,4.74,0,0,1,2.38-2.15c1.54-.61,3.08-1.21,4.65-1.73a3.8,3.8,0,0,1,1.54,0A12.9,12.9,0,0,1,79.35,8c0-1.76,0-3.46,0-5.15a1.8,1.8,0,0,0-.55-1,4.39,4.39,0,0,0-.88-.59C78.46.44,79.33.86,80,.6A18.5,18.5,0,0,1,82.09,0c0,.38.07.75.07,1.11,0,5.91,0,11.82,0,17.73,0,1,0,1.93,1.16,2.36C83.45,21.25,83.49,21.53,83.7,22Zm-4.34-2.2c0-3,0-6,0-9a1.12,1.12,0,0,0-.16-.61,4.63,4.63,0,0,0-3.81-1.27c-.66.2-1.3.48-2,.72a2.76,2.76,0,0,0-1.63,1.61,8.39,8.39,0,0,0-.09,6.49,4.51,4.51,0,0,0,4.89,2.91A17.22,17.22,0,0,0,79.36,19.77Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M66.44,21.62c-2.25.54-5,.41-5.79-.07A2.82,2.82,0,0,1,61,21a1.18,1.18,0,0,0,.28-1.53c-.69-1.59-1.36-3.2-2.09-4.91H57.15c-2,0-3.94,0-5.91,0a1,1,0,0,0-1.16.78c-.43,1.23-1,2.42-1.51,3.61-.38.85-.76,1.68.08,2.67-1.61.59-3.07.22-4.52.3L44,21.62a3.21,3.21,0,0,1,.73-.54,3.39,3.39,0,0,0,1.92-2q3.46-7.89,7-15.77c.32-.72.65-1.43,1-2.15.16-.38.35-.79.83-.65a1.27,1.27,0,0,1,.69.64c.91,2,1.78,4.07,2.66,6.11l5.19,12.12a3.52,3.52,0,0,0,1.71,1.74C65.91,21.25,66.17,21.44,66.44,21.62Zm-15.5-8.28h7.69L54.72,4.21Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M60.41,58c.77-1.55,1.46-2.93,2.14-4.32,1.38-2.82,2.69-5.68,4.17-8.45.7-1.32.72-2.37-.38-3.4-.22-.21-.41-.46-.8-.91a4.64,4.64,0,0,1,.76-.44c.64-.23,1-1.28,1.92-.68a2.5,2.5,0,0,1,1.25,3.12C69,43.95,68.55,45,68.06,46c-2.26,4.67-4.56,9.33-6.78,14a1.23,1.23,0,0,1-1.29.84h-.53c-1.28,0-1.28,0-1.69-1.15-.92-2.58-1.83-5.16-2.77-7.74-1.08-3-2.2-6-3.25-9a3.65,3.65,0,0,0-2.12-2.49,3.06,3.06,0,0,1-.68-.56,13,13,0,0,1,5.61.05c0,.08.06.21,0,.25-.83.73-.67,1.5-.29,2.44,1.94,4.85,3.8,9.73,5.69,14.59A6.62,6.62,0,0,0,60.41,58Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M122.71,21.59c-.83.45-4.15.54-5.67.15.18-.26.29-.58.5-.67a1.6,1.6,0,0,0,1-1.69c0-3,0-6,0-8.94a1.49,1.49,0,0,0-.92-1.57,5,5,0,0,1-.86-.72l4.33-1L121.21,9c.47-.13.91-.22,1.32-.37a12,12,0,0,1,4.55-1.05,3.53,3.53,0,0,1,3.36,2.06,10,10,0,0,1,.87,4.19c0,1.79,0,3.59,0,5.39,0,.83.06,1.56,1,1.92.2.08.3.42.6.87-1.45,0-2.62,0-3.79,0-.52,0-.6-.4-.6-.84q0-2.17,0-4.34c0-1.23.06-2.46,0-3.68a7.38,7.38,0,0,0-.61-2.38A3,3,0,0,0,124,9c-.91.28-1.8.63-2.82,1v1.8c0,2.37,0,4.73,0,7.1,0,1.05.15,1.91,1.26,2.32C122.51,21.27,122.59,21.45,122.71,21.59Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M155,8.15l4.43-.95c0,.48.06.86.06,1.25,0,3.55,0,7.1,0,10.65,0,.89.06,1.65,1,2,.17.07.26.37.46.69a26.21,26.21,0,0,1-4,.17l-.32-1A4,4,0,0,0,156,21a36.3,36.3,0,0,1-3.47,1.12,4.67,4.67,0,0,1-3.68-.39,4.37,4.37,0,0,1-1.93-3.41c-.17-1.43-.22-2.87-.26-4.31,0-1.23,0-2.45,0-3.68a1.37,1.37,0,0,0-.8-1.49c-.34-.14-.63-.32-.49-.84l3.85-.81c0,.38.09.71.09,1,0,1.88,0,3.77,0,5.65a26.92,26.92,0,0,0,.25,3.66,5.73,5.73,0,0,0,.84,2.17,2.89,2.89,0,0,0,3.25,1.18,30.24,30.24,0,0,0,3.22-1.07c0-3.18,0-6.24,0-9.3a1.71,1.71,0,0,0-1-1.7A5.67,5.67,0,0,1,155,8.15Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M128.46,60.63h-4l-.24-1a1.92,1.92,0,0,0-.41,0c-1.1.4-2.2.83-3.31,1.21a5.21,5.21,0,0,1-5.63-1.76,8.06,8.06,0,0,1-.76-8.42,4.49,4.49,0,0,1,2.6-2.44c1.5-.57,3-1.17,4.52-1.69a3.52,3.52,0,0,1,1.42-.07,4.22,4.22,0,0,1,1.26.33c1,.43,2,.74,2.81-.15.59.27.4.72.41,1.08,0,3.33,0,6.66,0,10,0,1,.06,1.92,1.18,2.35.07,0,.11.13.15.21S128.46,60.4,128.46,60.63Zm-4-6.66c0-1.27,0-2.53,0-3.8a1.83,1.83,0,0,0-.24-1,4.51,4.51,0,0,0-4.14-1.34c-.41.13-.81.32-1.22.44a3.3,3.3,0,0,0-2.22,2.05,8.16,8.16,0,0,0,0,6.35,4.48,4.48,0,0,0,4.65,2.9,6.77,6.77,0,0,0,1.74-.49c1.42-.54,1.42-.55,1.42-2Q124.49,55.55,124.49,54Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M156.9,46.79v1.28c0,3.29,0,6.57,0,9.86a2,2,0,0,0,1.25,2.19,4.77,4.77,0,0,1,.49.28,4,4,0,0,1-2.18.29c-.65,0-1.31,0-2,0l-.32-1.13c-1.13.39-2.24.75-3.34,1.15a5.08,5.08,0,0,1-6.38-2.08,8,8,0,0,1-.1-8.46,4.12,4.12,0,0,1,2.26-1.9c1.31-.48,2.62-1,3.9-1.48a3.87,3.87,0,0,1,2.92-.08c.08,0,.17,0,.25.07,1,.48,2,.81,3-.19Zm-2.66,2.53c-1.77-1.58-3.61-2-5.79-.94a3.68,3.68,0,0,0-1.83,1.74,7.78,7.78,0,0,0,0,6.69,4.41,4.41,0,0,0,4.59,2.78,11.21,11.21,0,0,0,2.59-.83,1.05,1.05,0,0,0,.45-.82C154.25,55.06,154.23,52.18,154.23,49.32Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M82.76,46.63v1.49c0,3.19,0,6.38,0,9.58,0,1.07.06,2,1.29,2.39a.36.36,0,0,1,.17.19,1.42,1.42,0,0,1,0,.34H80.19l-.19-1a32.34,32.34,0,0,0-3.09,1.12,5.34,5.34,0,0,1-7-2.68,8.14,8.14,0,0,1,0-7.31,4.5,4.5,0,0,1,2.73-2.46c1.32-.43,2.6-1,3.89-1.49A3.34,3.34,0,0,1,79,46.69c.4.16.85.21,1.24.38a1.45,1.45,0,0,0,1.8-.21C82.16,46.76,82.36,46.75,82.76,46.63Zm-2.65,12c0-3.06,0-6,0-8.92a1,1,0,0,0-.58-.93,4.56,4.56,0,0,0-4.78-.58A4.3,4.3,0,0,0,72.11,51a7.88,7.88,0,0,0,.15,5.37,4.53,4.53,0,0,0,4.86,3.17A20,20,0,0,0,80.1,58.65Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M189,14.67H179a5.26,5.26,0,0,0,1.14,4.17,4.84,4.84,0,0,0,4,2c1.54.05,2.78-.81,4.29-1.25a2.39,2.39,0,0,1-1.28,1.89,5.09,5.09,0,0,1-2.85.85,19.66,19.66,0,0,1-3.63-.31,5.93,5.93,0,0,1-4.37-4.28A8.57,8.57,0,0,1,177.53,10a5.55,5.55,0,0,1,4-2.34c2.26-.33,4.5-.26,6.16,1.65A6.61,6.61,0,0,1,189,14.67Zm-10-1.13h7.74c0-3.13-1.39-4.78-4-4.69C180.41,8.92,178.85,10.84,179,13.54Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M197.4,53.93c.27,3.53-2.65,6.76-6.68,7.22a7.3,7.3,0,0,1-7.8-5.58,7.41,7.41,0,0,1,1.53-6.5,3.59,3.59,0,0,1,1.89-1.33c.88-.25,1.71-.63,2.56-1a5,5,0,0,1,3.7.08A7.14,7.14,0,0,1,197.4,53.93Zm-2.67.32a8.81,8.81,0,0,0-1.35-4.69c-2.05-3-5.15-2.52-6.7,0a8.08,8.08,0,0,0,.52,8.95c1.9,2.39,4.56,2.22,6.3-.29A8.58,8.58,0,0,0,194.74,54.25Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M114.79,14.72H104.73a5.51,5.51,0,0,0,3,5.61c2.19,1.06,4.22.17,6.29-.82a1.31,1.31,0,0,1-.61,1.49,7.88,7.88,0,0,1-2.45,1.16,8.79,8.79,0,0,1-6-.76,6.41,6.41,0,0,1-3.26-5.23,9.61,9.61,0,0,1,.51-4.26,6.33,6.33,0,0,1,6.06-4.36,8.82,8.82,0,0,1,2.22.13c2.68.61,4,2.51,4.32,5.11A17.41,17.41,0,0,1,114.79,14.72Zm-2.37-1.14a5.65,5.65,0,0,0-.89-3.47,2.57,2.57,0,0,0-2-1.23,6.84,6.84,0,0,0-1.57,0,3.08,3.08,0,0,0-2.42,1.58,5.12,5.12,0,0,0-.89,3.12Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M201.58,8.9,201.14,12c-.41-.55-.67-.87-.89-1.21a4.58,4.58,0,0,0-3.19-2.08,3,3,0,0,0-3.21,1.88,1.48,1.48,0,0,0,.91,2.12c1.18.45,2.4.77,3.6,1.15.46.14.9.32,1.36.43a3.22,3.22,0,0,1,2.58,3.22,4,4,0,0,1-1.77,3.46,6,6,0,0,1-3.38,1.25,28.1,28.1,0,0,1-4.17-.24,1,1,0,0,1-.69-.51c-.38-.92-.68-1.88-1-2.83,0-.14,0-.33.08-.72a5.54,5.54,0,0,1,.63.78c1.49,3,5.12,2.68,7,1.72a2,2,0,0,0,1-2,1.87,1.87,0,0,0-1.28-1.8c-1-.35-2-.57-3-.92a15.49,15.49,0,0,1-2.4-1,3.55,3.55,0,0,1,0-6.14,7.45,7.45,0,0,1,7.15-.23C200.8,8.48,201.14,8.67,201.58,8.9Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M170,56.79c.28.42.5.71.68,1a4,4,0,0,0,3.54,2.1,6.14,6.14,0,0,0,2.94-.46,2,2,0,0,0,1.32-2.19c0-1.06-.38-1.5-1.5-1.86-1.45-.47-2.93-.84-4.34-1.39a3.54,3.54,0,0,1-2.49-2.63,3.79,3.79,0,0,1,1.76-4,7.87,7.87,0,0,1,8.16.5l-.41,3c-.34-.46-.53-.67-.67-.91a5.1,5.1,0,0,0-2.92-2.3,3,3,0,0,0-3.73,1.94,1.41,1.41,0,0,0,.75,1.85,15.94,15.94,0,0,0,2.19.81c1.07.35,2.15.69,3.24,1,2.24.62,3.1,3.77,1.43,5.73a5.74,5.74,0,0,1-2.45,1.69,11,11,0,0,1-5.93.19,1.07,1.07,0,0,1-.72-.47c-.4-1-.73-2-1.07-3.07C169.74,57.22,169.86,57.09,170,56.79Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M139.49,7.64h3.59c.2,1.37.12,1.49-1,1.51-.78,0-1.56,0-2.44,0,0,.38-.1.71-.1,1,0,2.62.07,5.25,0,7.87a2.9,2.9,0,0,0,2.09,3.2,1.08,1.08,0,0,1,.3.22s0,.08.08.21c-.15.08-.33.25-.48.24-.95-.11-1.89-.29-2.83-.4a2,2,0,0,1-1.69-1.74,8.9,8.9,0,0,1-.22-1.94c0-2.36,0-4.72,0-7.08V9.41l-2-.13c.17-1.17,1.38-1,2-1.77,0-.5,0-1.16,0-1.8A1.85,1.85,0,0,1,138,3.57a10.34,10.34,0,0,0,1.08-.51c.74.67.32,1.51.4,2.24S139.49,6.76,139.49,7.64Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M86,8.13a13.56,13.56,0,0,1,5.63.06c0,.11,0,.28-.09.34a1.36,1.36,0,0,0-.37,1.84c1.17,2.72,2.27,5.46,3.41,8.19a7.74,7.74,0,0,0,.4.7l1.73-4.08c.51-1.2,1-2.41,1.54-3.6a1.77,1.77,0,0,0-.27-2.16,3,3,0,0,1-.3-.5l1.44-1.17c.21.19.36.35.53.48a1.66,1.66,0,0,1,.48,2.31c-.46,1-.88,2-1.32,3L95.41,21c-.54,1.21-.54,1.21-2.09,1.13-.7-1.65-1.44-3.37-2.16-5.08-.94-2.25-1.89-4.49-2.81-6.75A2.87,2.87,0,0,0,86.8,8.65,7.65,7.65,0,0,1,86,8.13Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M91.17,39v1.62c0,5.69,0,11.38,0,17.07,0,1.16.16,2.08,1.35,2.53.08,0,.11.2.22.42H87c.31-.33.46-.61.68-.71a1.41,1.41,0,0,0,.85-1.47q0-8.14,0-16.28a1.43,1.43,0,0,0-.83-1.48,3.21,3.21,0,0,1-.66-.6c.63-.67,1.4-.3,2-.54A21.38,21.38,0,0,1,91.17,39Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M174.3,7.93l-.38,3.68c-.33-.17-.59-.22-.72-.38s-.25-.56-.43-.81a2.08,2.08,0,0,0-3.8.42,12,12,0,0,0-.48,2.68c-.07,1.84,0,3.68,0,5.52a1.93,1.93,0,0,0,1.26,2.18.58.58,0,0,1,.2.17s0,.08.07.23c-.17.1-.37.32-.57.33-1.61,0-3.23,0-4.77,0-.37-.54-.08-.8.24-.93.81-.31.93-.92.92-1.69,0-2.85,0-5.7,0-8.54,0-1-.2-1.8-1.27-2.14-.1,0-.16-.19-.29-.37.53-.73,1.38-.33,2-.56s1.33-.36,2.08-.56l.18,1.77c1.21-.42,2.34-.8,3.46-1.22A2.45,2.45,0,0,1,174.3,7.93Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M137.38,60.62h-5.95c.38-.36.55-.63.79-.72a1.53,1.53,0,0,0,.95-1.57q0-4.53,0-9.06a1.48,1.48,0,0,0-1-1.53c-.33-.12-.64-.34-.46-.79l4.07-.9.11,1.8,2.74-1a4.19,4.19,0,0,1,2.3-.33c.45.08.7.31.64.81-.11,1-.21,2-.34,3.15-.28-.11-.59-.14-.74-.31a8.81,8.81,0,0,1-.49-.92,2.07,2.07,0,0,0-3.63.24,6.56,6.56,0,0,0-.52,2.39c-.07,2.06,0,4.12,0,6.17,0,.9.1,1.65,1.07,2C137,60.07,137.09,60.26,137.38,60.62Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M161.2,47.51l4.23-1c0,.3.09.62.09.94,0,3.5,0,7,0,10.5,0,.88,0,1.66,1,2,.17.06.26.37.4.59a13.29,13.29,0,0,1-5.69-.1c.24-.23.41-.49.64-.59a1.39,1.39,0,0,0,.84-1.48q0-4.33,0-8.66c0-.75-.08-1.39-1-1.6C161.57,48.12,161.45,47.82,161.2,47.51Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M89.57,28.89l-.26.48c-.73.08-1.46.19-2.2.23-1.87.1-3.74.18-5.61.26L75,30.11l-6.66.27c-2.53.1-5.05.19-7.58.28l-9,.26v-.48l6.68-.3,13.49-.54,6.42-.26,10.61-.49C89.13,28.84,89.35,28.87,89.57,28.89Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M10.54,32.08c-1.69.69-3.17,1.31-4.66,1.87a1.73,1.73,0,0,1-1.12,0c-1.52-.57-3-1.2-4.76-1.91,1.41-.6,2.59-1.11,3.78-1.59,1.46-.59,1.47-.59,2.91,0C7.9,30.95,9.08,31.46,10.54,32.08Zm-3.3-.62c-1.38-.87-2.59-1-3.86,0Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Compound Path>","d":"M140.76,32h-4.34c-.11,2.38,1.31,3.13,4.13,2.2-.13.77-.73,1-1.27,1.15a3.48,3.48,0,0,1-4.08-1.56,3.82,3.82,0,0,1,.8-4.44,3.4,3.4,0,0,1,3.56-.45A2.62,2.62,0,0,1,140.76,32Zm-1-.58c0-1.5-.44-2.2-1.47-2.27s-1.79.73-2,2.27Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M108.23,29.11c.18-.52.63-.53,1.06-.51a3.43,3.43,0,0,1,3.12,3,3.34,3.34,0,0,1-2.28,3.57A3.39,3.39,0,0,1,106,30.49a2.16,2.16,0,0,1,2.28-1.39,3.52,3.52,0,0,1-.41.48,3.51,3.51,0,0,0-.19,4.55,1.66,1.66,0,0,0,2.41.43,3.36,3.36,0,0,0,.84-3.7C110.35,29.48,109.85,29.11,108.23,29.11Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M170.29,29.89v-.46l6.66.22c3,.1,5.92.19,8.88.32,2.61.12,5.21.28,7.82.43.34,0,.69.08,1,.12l.07.4-5.46-.22L183,30.44l-8.21-.28c-1.09,0-2.18,0-3.27-.06A9.77,9.77,0,0,1,170.29,29.89Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M115.59,28.44c.62.37,1.4-.16,1.69.85l-1.52.13c-.44,1.5-.28,4.81.3,5.71H114a17,17,0,0,0,.3-2c0-1.18,0-2.36,0-3.61l-.94-.37a1.42,1.42,0,0,0,1-1.62,1.62,1.62,0,0,1,1.39-1.9c.3-.06.57-.21.86-.3.64-.18.65-.17,1,.77-.61.08-1.31-.54-1.78.21S115.63,27.83,115.59,28.44Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M122.76,29.52l-.92-.28c.65-.35,1-.73.94-1.46s.36-1,1.16-1.07l.13,1.86,1.74.12c-.24,1.11-1.22.41-1.8.9,0,1.29-.08,2.68,0,4.06,0,.52.54,1,.83,1.48a2.82,2.82,0,0,1-.41,0c-1.33,0-1.67-.38-1.72-1.73,0-.87,0-1.74,0-2.62C122.76,30.38,122.76,30,122.76,29.52Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M160.1,43.55a5.78,5.78,0,0,1,.67-.71q2.36-1.64,4.74-3.24a3.88,3.88,0,0,1,.67-.4,1.2,1.2,0,0,1,1.4.38,1.28,1.28,0,0,1-.45,1.59,9.73,9.73,0,0,1-1.2.49c-1.63.6-3.26,1.2-4.89,1.78A5.05,5.05,0,0,1,160.1,43.55Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M129.07,29.44a1.28,1.28,0,0,0-.58,1.09c0,1,0,2.1,0,3.15a7,7,0,0,0,.46,1.5h-2.49a1.73,1.73,0,0,0,.93-1.8c0-2,0-3.94,0-5.91a1.89,1.89,0,0,0-.74-1.89l1.83-.31c0,1.19,0,2.32,0,3.46,0,.33,0,.63.46.6Z"}}),_vm._v(" "),_c('path',{style:({'fill': _vm.color}),attrs:{"data-name":"<Path>","d":"M129,29.32a10.12,10.12,0,0,1,1.16-.51c1.9-.57,3,.16,3.07,2.14.05.87,0,1.75,0,2.63a9.69,9.69,0,0,0,.34,1.5h-1.64c0-.89,0-1.79,0-2.7,0-.39,0-.79,0-1.18-.09-1.5-.69-2-2.2-1.84l-.65.08Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-nav"},[_c('div',{staticClass:"nav-toggle",class:{ expanded: _vm.menuIsActive },on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('div',{staticClass:"nav-toggle-bar"})]),_vm._v(" "),_c('nav',{staticClass:"nav",class:{ expanded: _vm.menuIsActive }},[_c('ul',[_c('li',{on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('router-link',{attrs:{"to":{ name: 'Index'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('router-link',{attrs:{"to":{ name: 'About'}}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('router-link',{attrs:{"to":{ name: 'Npe'}}},[_vm._v("New Pirate Economy")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('router-link',{attrs:{"to":{ name: 'Trainings'}}},[_vm._v("Trainings")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('router-link',{attrs:{"to":{ name: 'Volunteer'}}},[_vm._v("Volunteer")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('router-link',{attrs:{"to":{ name: 'Partnership'}}},[_vm._v("Partnership")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('router-link',{attrs:{"to":{ name: 'Services'}}},[_vm._v("Book Us")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.menuIsActive = !_vm.menuIsActive}}},[_c('router-link',{attrs:{"to":{ name: 'Contact'}}},[_vm._v("Contact")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"flex-between",attrs:{"id":"top-bar"}},[_c('valpo-main-nav'),_vm._v(" "),_c('section',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{ name: 'Index'}}},[_c('valpo-logo')],1)],1),_vm._v(" "),_c('valpo-socialmedia')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoFooter_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcbb06fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoFooter_vue__ = __webpack_require__(121);
function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bcbb06fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcbb06fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer content flex-around",attrs:{"id":"footer"}},[_c('div',{staticClass:"socialmedia"},[_c('h4',{staticClass:"align-center"},[_vm._v("Join us on our journey!")]),_vm._v(" "),_c('valpo-socialmedia')],1),_vm._v(" "),_c('p',{staticClass:"align-center"},[_c('br'),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.images.logo),expression:"images.logo"}],staticClass:"logo",attrs:{"alt":"Adventures of the Valparaíso"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n    Site by "),_c('router-link',{attrs:{"to":{ name: 'About', params: { focus: 'crew' }},"title":"Art & Design"}},[_vm._v("Alexis Camejo")]),_vm._v(", "),_c('router-link',{attrs:{"to":{ name: 'About', params: { focus: 'crew' }},"title":"Development"}},[_vm._v("Timo Heddes & Ramiro Ramirez")])],1),_vm._v(" "),_c('p',{staticClass:"align-center"},[_vm._v("\n    Stichting Adventures of the Valparaíso"),_c('br'),_vm._v("\n    NL32TRIO0338494154\n    "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'PrivacyPolicy', params: {} }}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n    © 2014-"+_vm._s(_vm.thisYear)+" All rights (and lefts) reserved\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/53gradennoord.1240d16.jpg";

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQEAAACsCAYAAAB7GRl5AAAACXBIWXMAAD9GAAA/RgHkW2BAAAASPklEQVR42u2d63HbyBKFj7f2P3kjEByB4AgERSA6AsMRmI7AUARLRWAogoUiWCiCC0ZgKIJLRsD7A4MSFsZrZnpAPM5XxfIubeI5faa7p2fmw+VySUEIWSv7D5fL5cLnQMhquf+Dz4CQdUMRIIQiQAihCBBCKAKEEIoAIYQiQAihCBBCKAKEEIoAIYQiQAihCBBCps4zgE8A3igChKyP7wBCABmAvelB/lyZYmbq4wP4i22IzJSzMv5E/f8WQGx6sLVMJT4qw6+SA7hheyIz4w3ATnVmJRmAW8PjrWYqcZOrFLE9kZl2ZlUBiC0EYDU5gVcAacP3sXKrCJlLOOsDOFW+CwF8sT3wGkSgq8c/sG2RGVAmAKv4AH5KHHzpIvDS4gVURYDeAJkqZwBfGzqrLd6TghQBg1xAlRO9ATJhAQjQnPWPIZjUXrIIPKMYAegjZnsjE+MIwMO/E4AlOwAPkidbsghEA/9drgSDkKl0XgH+nQCshgHindZSReBxoBegKxiEuG63YYsAQIWuG+mTLrFY6KxcqZPm7xJpN4sQjTa77+nlPQC/HJx7kcVCBwMBKH9HyDUEIBjg5jvzVpfmCbzh94IKHXKwlJgM40m1l61qc1sAd5rHOHbE//VcwP8c3cf90iYQRRYCUP7+J9s3Geg55i0G6yv3vfrxa/H8swoBhrTX0OWNLMkTeFMP2waXikuW5XGatrVA/ZlOxENdlCcgETOdlEJ/YTsnPZ1F3YhTFMnlrOe3qea5fNch6lI8gdeKwtqyA/A32zmx8BIiyI3nHwB8c3i990sRgXsDhe3zCDZsz8SCF3SP+U+lLS5iiLBpqvAWFsstQXByBlktD6pdbi29Uued0RJEoJ4LCFAkUnYUAXJlbmGXq9qNcZFzF4HnmhcQAfhHqeedxXFTtl8ixDeY56sS5ek6Ze45gY94L9hIGgz/g6U3wDJiIhWyBha/91R+IYT8SMGscwJHFEmT0v2vC8Cb5fHpDRAp7mBXw5IrL9cD8BlF0pHhgIq3sor7Xye0PD7zAkSSvdBxEpUr+Ihi1uF5zSKADteob1mxoep7ZNslQgTCxyu9g62tGCxxFuFZWHUJkfJct46OXYYKTxSBgraJHRQBcm18h8c+wXAZ/aWJQFmyKUUGrkZM5iECvgqBN2sXgdDBMekNEClchQOBqQAsTQTqhUMUAbIGUYnQPkI2iKVMJZZMBtZJ2dbIRL1ekYVHl+IJRLCfrdXGCcLFGYRYGn+OYgUskclFSxCBI9wvEkpvgFy7HVWNX7R0eAkisB/hHC7zAm+0jdWQTcn4lyICrpKBdXKHxhqi2HSSLJujQcgauTT+JYiAy2TgWN5AuSBKTCFYPCYh6yhh6JxFIIK7ZOBYLySq/HeM+e6J+Iqifr38PF8hzHkG8AnF9PEPAL7DvNCr3BJc6n2cMeWh5ss8yS6XCww+vuHvys9J8B7SlnPEM3kH+eVyCS+Xy7bjeQXqPl2SXC4Xr+X8O8O2VW0nicA1RobtLRjhPQZz9QRMw4AD7Eo3Jb2BsOP7qXsEjygmrMQ93liKoprtu6Nw8DOKabV5Rwin8yxf1PVmtfdhM5v0DRPf4m6OImCaDNyhWNxhCmsPPqN7ktNUheCoXO7IQHw/QW4exqsSoSHvI9J4J7sGUSsXrjEVgnDksHXxImCTDCzVOJiAJxANbDxTWs/guaGX1CFTv7cVgkcM27+vJB8gqM/onndyUgKhe+1Plm0mpwjIJQNDvA+z3Fm+lKOAMQ19ucFEhOBZqEfLLET4jGJ/icjgt4mFAFTfvY6IHWE/o5Ui0PBQTWKrbcPLsAkJbL0BnYZxmoAQDDUSHSHQHQ59Ue6/6bNPWoz3qHlvQ0Xs3BJaMBywZG/xu3qxhU1y0CYv8Gig7tcUAmkBKIkxbD5GNflna1BJi4foQsR2Y/XiaxIB02Rg205EtnkBk7j2DPMssWlM6lIAQkuBCNFdS1D2/lLJ2LRBkE3zG3GHEHztaavbyVnXDMajTz1j0V2fqOO4NvUCyYhjxfU6h9MIzzzuuQ6vch2xxf3sWt73TuBZ1T/bWo3DVuCYh9q1H3r+fdhRH9L2cV4nMAcR2Bu+IK/nuDaFQ+GIQja2EAwpxEobfrMVENRk4HECw3Nl6jySIhMPFMN9T5HY0Ge9umIhm2nC0YBQYay8wEEwSSQ11Nb2vIMBbnx9hOUW5ptv7jVi/zI5+I9FSPAC2RLeUIUW+57w4S/mBMZNBvoAvvT8G5u8wEkzURcLP5cM8ptVlgLQJ1Zt4moqBDnet5HrO++vigCZvL9Eo00dAFzUJ1XGvu24tlNLR5PV2qJHEXCfDATGKdNMNI02Ej5/CrmZh0MFIET3tNZbB4Lnq+f3Q+iZ9WXtPXW+b5Xv7lBM6c00jHirzndb+/6GIjA8k27qBQSwKwhyIQIb1YhzyO5EEwsIwRnDK/CGeB8PkJviHbYYEiC/o095vqzlfKUB7y0EgOGAZjx/svjt0F7B1iXXjctvVDybCrqFNkKgIwBbDN+lOYL9UNgBguvoDXyOQ84X9tybtADkaxSBVwt3PhzoBRwhMw/ANMF0p+LbA2TGjWMUySkTwRw6Vq7T824svYG45o63hQkSNMXtNvd2EPYAVikCNo0nGigAUq6krZB8Uy9Zwn2OoDfzUFds/ZHe436gQUqIp6+e/63BNfoN15NoiAnDgRaeYF7FFaI96XJGMTT0Wb08qeE6iaGmDYrhI4l8QaghBKGBwejel29wjqFDaZ6AAKSG4cZGvfug4iWlGuHSpJjS5iNn2GXQd6p3y5SR5+qTwe2eBEch96/MF7zifYVZUyFAT4/0anD8raGh6Yh6rPm8bEKAxDLfUL6v2TMlEdhbGuvuStcdQ7YQpMwXPMK8yChWz2PjKIwZiqf5/m4NjNn0+dyATCoceIX8+PJYuDKockgx1DS6BP1705lcs+thVxMR9w1/Mye3PVuLCOwxXzK4W1l3g2LYqs9AyjUTfk2sges04GCkawpn1r5OaxABm2SgS/d0Ct5AuZpO0tOoc+hV1JkYnMl6Bjp5BxP33OQ+fJBJiYBNMtBveaGeahyRMp4c7zXgvyr/nQj2Ci7WlD+iezWdQInnWAU1uj3S24jiTiy4dmIwtHB3dpXe782gN3nAe4lraNlgpUXgqSNE8lAkDKce18YjnMOkV7+j2U/HE3gVNJ4bmGd7y9lvtl6BxPbl5ZTafUfcn11JAPIJioDJsOVxZja66JyArdEFgtdSJuBsjmmbFygrGdvWwitn0m2u9L50RODJQDRMjPNuikYlzGJHB0wW3ByDBObJQxuvpm1N/0CJi/OdaQWNxzTPYyqi24WLwCJzAlLbMoUNBuvXGsW2IW70Ogxqo9xYE48gh1n14PeW5xFBZg69VCydabyXk6EIfDO8l1TzPh5o+tcVAdvKwKrR5UK9iQ+ZCSmphgic0b2jTwyzKjpXsfQQz+3ZwiMq9wbQDXc8g3f0g6Z/vXBAen03ybgrrXxMiQf+u3IvvazH6HwVX0+BPhE4wr7oKzb4jW/wrsmVROCMeVcGDm1gfdWDunvp7VEUDJ0ncH+vPV7NaQYioLs+5BR4W4oIHGCXDNyqhhZM/IWlHYbyGeZJM6/DCHUxHSs/aQjAziDsyEa6l3RmIpBriIV2GxkrJ/AG+4U2T2ieunmsNMBTrSGltQY2Rma4aWGJI+y3piq3I4uuGNPWk2pdeY2Dulbd3v3VwLB1pyynMEtCuvSmbGwrUc+5XAj11xRFIBTMKdQzu/XEWfXvf3Q8uLxHOHJDo63nPJ4hlwwF3suhE9jPqde9pnygAJT7PwYYp2goMBABHaP1MK2px3XD7/PWupnAllYud/6xIRHYpiwV3HmoaVutxGbnGYNzBpUdlfyO6zoZ7rZjusVbYrEbUdeuUaGDXYBMnkmqtk47DNg5K5naDkTSycAxY7kHmA8bJpV4deh21ibhwQ7FSsNjJQ1z9A9t7mFX1ZgZegKSbelJ9f6xZQ5F0pP21LPtej57GNRAuBaBSDgOz0d++IGFCJSGWS5DJbWycJ0YZluXe4bPvyv+3uI6I0Ab6C9Kkrbkl+5r4dsUph4Pafc66zOOJgI2S4dPBdMly04N9/7NoVdQHvfJsQj0NUhbL8CGvYUInFFUbjZVH+5m0E63NrmXPyb0UpYkAlAiUHfTXXoFJ/XMPw8MDzzh83sN73w74ru60xTYk0qwvSjjP3S44tLPSRqrvQ5ciYCr1YKCkUVgAztvIGr5O5deQaIadV94IN3DRQ1ewO3IQhAZtKeuodtylEOSG2EhCGG514ELEZCoCViSN3DsaAyuvIIydn/sETipXs7raIjSHuEL2ivo7jTPl/fE2K7asZT4+xIhtwsRkBwTn7sIDDECl15BhO6SYykB6jKWHwL39oJiFOQ/6N8LMBLoaT2Yb0ziwmNpI5a4RmkRkFwtaArhQNlj2mSIU/Qn7Fx6Balq1C8t95ZaGo03wB1NDO6ravg71eDLvMem533Flr1rBrcJzhsBL0xuz0PBIojT5XLxHBXGlJ/4ch0OAoU9+cBz5YaFPEM++453tzM8ZipcJON1FFhVC5H6iAzuJRqxTZ0sCsl2gtcRSIpA5FgAoNEApMkFrj0wqLR0UW3odwjSQfOcwchiqmukoUYlan6FdpUZvGNP2A7ERCB3bPy+ZYmsBL7AfSQGvcXu4qbkOBbwREzKaUOLazZp/EGHMUVXMn4bIUiFzy9WNhw6iJu2eF9g87+4/pJQEveomy/ZAPjbMKbuG74M0VxyPDQ/EcCsnPan4bM0LUT6p3a+UD3PXyppee2JQbeqjQ/JO0VwUML84XK5XASSgZIJu536TG2f96NGgtDD++Yo5ce2sZ0rDVgSTx2zKcn0ps6ZtiQcbRrkV40Enq86Atv35+F6FY1DeEJ7qX0AN7sg30uIwGeBhumrxrbDtHeL/Yjfx5aDBqN32dBeYLdpS1e2uW2OfX06dKh6dIlG3zeEuoXe2o1z56zeRXVH6q1qd5spisDZwk2di+HXG+1JXbt3xYb5Bjflp+VQ3KbHE8kF31m5NmGq6aWsQQziiiC4CoetRUAnFCiXB9upP7k/vHnjCOBuwcw+1/voyCiPyuCzSlv5wtftHBFPwOuIYTz1p79SNXdhKLbLlHXlBiIa3vpEwHZ5sY1qkFmtJ9nw2ToRgMBBLiCAo6wzmQcSiUEyTwEIlfEzLKMnQFYkAOXKP9dc/INMDIrAOgSgjPd3NH5S5w8+gsnyIiAAAd6r475QAAg9gfnwDLsy5VB9mOwjFIGVCUAIJvsIRWCVAkDjJxSBlQoAjZ9QBBaCzow6oMjyH2j8RAKODsxLAAIUE23+pgAQegLrEoCt6vlZ10/oCaxQAPYo5mdQAAg9gZUJQLmxBMf6CT2BFQpAhGJOPwWA0BNYmQD46u+59gKhJ7BCASh7fwoAoSewMgHYopjkQ9ef0BNYoQAEKDL/FABCEVgojx0CEKFYR57TewnDgYXyjPYtqGNw3J9QBBYvAGFL/J+CyT/CcGDRlJtpUAAIRWCFvKF5STAKAKEIrIQdBYBQBNbLI37fGowCQCgCK8oDRA3fHygAhCKwDvYt33EYkEwebkNmT9POzB6Ktf4JmTr39ATsiRu+2/GxEIYD6+BMESAUgXWTtHy/5aMhFIF1kLV8zxEBQhFYuQgQQhFYOWc+AkIRoIdAgSEUAeKEPYCPAL6jqFQkhCJwRbyW71OH50xRLEl2QLE68SeKAaEIXA9/5HDgqASgfi7WJRCKwJXYjSwCecf39AYIReAK3OD3eQMujdLr+LuEr4NQBK5DNGJe4LZFdFx6H4QiQHq4azHMg6PzhS3fn/gqCEXgesT4fb5AjmKasTRMAhKKwERzA7FGqGDDBpygRCgCk+ShIQRIHXkDTa6/z1dAKALX51tDzL6DbKnvG8MEQhGYNj/x7zUHTygShxJCcG4x9gDc1JRQBCbFX7UcQabcdZvQoFzLMGsIA1gjQCgCE+SLMlhP/X+ujPhrh0vfxAuA+w4BSMGdjYkFXG3YPWcUowSHBgPeqT+3tfAhU5+u5cv2AH7w8RJL7ikC4/GqxCC1OEZp/Hv2/oQiMF+OKl+QoH1CUJ1d5UPjJxSBhQlCpsQgw/v4f6B6fR/M+hOKACHEpQhwdICQlUMRIIQiQAihCBBCKAKEEIoAIYQiQAihCBBCKAKEEIoAIYQiQAhZA3+iWLCCELJOsv8DmFsXUbRw/q4AAAAASUVORK5CYII="

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glas_in_lood_boot_partners.1cc5dce.png";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/horeca_partners.b95ed17.png";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/erasmusplus.b513c28.png";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/european_commission.009a3cb.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tastebefore.e454b5e.jpg";

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"partners content flex-around",attrs:{"id":"partners"}},[_c('valpo-list',{staticClass:"icons flex-center"},_vm._l((_vm.ourPartners),function(item){return _c('valpo-list-item',{key:item.icon},[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.icon),expression:"item.icon"}],attrs:{"alt":item.alt}})])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('valpo-top-bar'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('valpo-partners'),_vm._v(" "),(_vm.$_config.site.mode === 1)?_c('valpo-footer'):_vm._e(),_vm._v(" "),_c('cookie-law',{attrs:{"theme":"base"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(28);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  base: __dirname,
  transitionOnLoad: true,
  linkActiveClass: "active",
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    var focus = to.params.focus;

    setTimeout(function () {
      focus && document.getElementById(focus) && document.getElementById(focus).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, 300);
  },

  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
});

// Global navigational guards and hooks
router.beforeResolve(function (to, from, next) {
  document.title = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].site.name + " - " + to.meta.title;
  next();
});
// Scroll to top after routing to a new page
router.afterEach(function () {
  window.scrollTo(0, 0);
});

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 137 */,
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Index__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Volunteer__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Npe__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Partnership__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Contact__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Error404__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Construction__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Services__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_PrivacyPolicy__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Trainings__ = __webpack_require__(294);





// import Activities from "@/pages/Activities"








var routes = [{
  path: "/",
  name: "Index",
  component: __WEBPACK_IMPORTED_MODULE_1__pages_Index__["a" /* default */],
  meta: {
    title: "Adventures of The Valparaiso"
  }
}, {
  path: "/become-a-volunteer",
  alias: ["/volunteer", "/volunteering"],
  name: "Volunteer",
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Volunteer__["a" /* default */],
  meta: {
    title: "Become a Volunteer"
  }
}, {
  path: "/about-us",
  alias: ["/about", "/history", "/history-of-the-valparaiso"],
  name: "About",
  component: __WEBPACK_IMPORTED_MODULE_3__pages_About__["a" /* default */],
  meta: {
    title: "About Us - History of the Valparaiso"
  }
}, {
  path: "/npe",
  alias: ["/new-pirate-economy"],
  name: "Npe",
  component: __WEBPACK_IMPORTED_MODULE_4__pages_Npe__["a" /* default */],
  meta: {
    title: "The New Pirate Economy"
  }
}, {
  path: "/trainings",
  name: "Trainings",
  component: __WEBPACK_IMPORTED_MODULE_11__pages_Trainings__["a" /* default */],
  meta: {
    title: "Trainings"
  }
}, {
  path: "/book-us",
  alias: ["/services"],
  name: "Services",
  component: __WEBPACK_IMPORTED_MODULE_9__pages_Services__["a" /* default */],
  meta: {
    title: "Hire our Services"
  }
}, {
  path: "/partnership",
  alias: ["/investors"],
  name: "Partnership",
  component: __WEBPACK_IMPORTED_MODULE_5__pages_Partnership__["a" /* default */],
  meta: {
    title: "Partnership & Investors"
  }
}, {
  path: "/contact",
  alias: ["/contactu-us", "/email"],
  name: "Contact",
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Contact__["a" /* default */],
  meta: {
    title: "Get in Contact"
  }
}, {
  path: "/privacy-policy",
  name: "PrivacyPolicy",
  component: __WEBPACK_IMPORTED_MODULE_10__pages_PrivacyPolicy__["a" /* default */],
  meta: {
    title: "Get in Contact"
  }
}, {
  path: "/facebook",
  name: "Facebook",
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Contact__["a" /* default */],
  meta: {
    title: "Get in Contact"
  },
  beforeEnter: function beforeEnter() {
    location.href = "https://www.facebook.com/adventuresofthevalparaiso/";
  }
}, {
  path: "/twitter",
  name: "Twitter",
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Contact__["a" /* default */],
  meta: {
    title: "Get in Contact"
  },
  beforeEnter: function beforeEnter() {
    location.href = "https://www.twitter.com/";
  }
}, {
  path: "/youtube",
  name: "Youtube",
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Contact__["a" /* default */],
  meta: {
    title: "Get in Contact"
  },
  beforeEnter: function beforeEnter() {
    location.href = "https://www.youtube.com/channel/UC1XzBAvMDmw21mgIdFbMbfw";
  }
}, {
  path: "/instagram",
  name: "Instagram",
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Contact__["a" /* default */],
  meta: {
    title: "Get in Contact"
  },
  beforeEnter: function beforeEnter() {
    location.href = "https://www.instagram.com/adventuresofthevalparaiso/";
  }
}, {
  path: "/static/New-Pirate-Economy-manifesto.pdf",
  alias: ["/manifesto"],
  name: "Manifesto",
  meta: {
    title: "The New Pirate Economy Manifesto"
  }
}, {
  path: "/static/Adventures_footermail.jpg",
  alias: ["/Adventures_footermail.jpg"],
  name: "Emailfooter",
  meta: {
    title: "Adventures of the Valparaiso"
  }
}, {
  path: "*",
  name: "Error404",
  component: __WEBPACK_IMPORTED_MODULE_7__pages_Error404__["a" /* default */],
  meta: {
    title: "Error 404 - Page not found"
  }
}];

if (!__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].site.mode) {
  routes = [{
    path: "*",
    name: "UnderConstruction",
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Construction__["a" /* default */],
    meta: {
      title: "Under construction"
    }
  }];
}

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var api = {
  base: ""
};

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var firebase = {
  enabled: false
};

/* harmony default export */ __webpack_exports__["a"] = (firebase);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67707d0b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67707d0b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67707d0b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"splash splash-youtube fixed-pseudo flex-container flex-center",style:(("backgroundImage: url(" + _vm.image + ")"))},[_c('youtube',{ref:"youtube",staticStyle:{"position":"fixed"},attrs:{"video-id":_vm.video.src,"player-vars":_vm.playerVars,"width":_vm.windowsWidth,"height":_vm.windowsHeight},on:{"playing":_vm.playing,"paused":_vm.paused,"ended":_vm.ended}}),_vm._v(" "),_c('div',{staticClass:"splash-slot",class:{ hidden: _vm.isPlaying }},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content flex-container"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"animated"},[_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoEvents_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e17e8cf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoEvents_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e17e8cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e17e8cf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoEvents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoFbEvents_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ecebfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoFbEvents_vue__ = __webpack_require__(189);
function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoFbEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ecebfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoFbEvents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fb-events",attrs:{"id":"fb-events"}},[_c('iframe',{staticStyle:{"border":"none","overflow":"hidden"},attrs:{"width":"410","height":"512","frameborder":"0","scrolling":"no","src":"https://www.facebook.com/plugins/page.php?href=https://www.facebook.com/adventuresofthevalparaiso//&tabs=events&width=410&height=512&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId=2047805032153957"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"events-list"},[_c('li',{staticClass:"event"},[_c('valpo-fb-events')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"two-col-section"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship-water.b7af57a.jpg";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/graphic-boat.752c69e.jpg";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image-hand.114afc1.jpg";

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-connect.b0d91b6.svg";

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ny44IDQ3LjgiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMDA2Mzg3O30uY2xzLTJ7ZmlsbDojMDE1NTZiO30uY2xzLTN7ZmlsbDojNjc5OWE1O30uY2xzLTR7ZmlsbDojNGM3Zjg3O30uY2xzLTV7ZmlsbDojMDNkNmRiO30uY2xzLTZ7ZmlsbDojMDBiMWJkO30uY2xzLTd7ZmlsbDojMmVhYzA0O30uY2xzLTh7ZmlsbDojMmU5NDA0O308L3N0eWxlPjwvZGVmcz48dGl0bGU+QXNzZXQgMzwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkNhcGFfMSIgZGF0YS1uYW1lPSJDYXBhIDEiPjxnIGlkPSJfR3JvdXBfIiBkYXRhLW5hbWU9IiZsdDtHcm91cCZndDsiPjxjaXJjbGUgaWQ9Il9QYXRoXyIgZGF0YS1uYW1lPSImbHQ7UGF0aCZndDsiIGNsYXNzPSJjbHMtMSIgY3g9IjIzLjkiIGN5PSIyMy45IiByPSIyMy45Ii8+PHBhdGggaWQ9Il9QYXRoXzIiIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBjbGFzcz0iY2xzLTIiIGQ9Ik0yNi4xNiw0Ny42OUEyMy45LDIzLjksMCwwLDAsNDcuNjgsMjYuMjVMMzUuOSwxNC40OGwtMTEsNS44LDEuNTksMS41OUwxMi4zOCwzMy45MVoiLz48Y2lyY2xlIGlkPSJfUGF0aF8zIiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgY2xhc3M9ImNscy0zIiBjeD0iMjMuOSIgY3k9IjIzLjkiIHI9IjE1LjI2Ii8+PHBhdGggaWQ9Il9QYXRoXzQiIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBjbGFzcz0iY2xzLTQiIGQ9Ik0yMy45LDguNjRoLS4wNVYzOS4xNmguMDVhMTUuMjYsMTUuMjYsMCwwLDAsMC0zMC41MloiLz48Y2lyY2xlIGlkPSJfUGF0aF81IiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgY2xhc3M9ImNscy01IiBjeD0iMjMuOSIgY3k9IjIzLjkiIHI9IjEyLjM5Ii8+PHBhdGggaWQ9Il9QYXRoXzYiIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBjbGFzcz0iY2xzLTYiIGQ9Ik0yMy45LDExLjUxaC0uMDVWMzYuMjloLjA1YTEyLjM5LDEyLjM5LDAsMSwwLDAtMjQuNzhaIi8+PHBhdGggaWQ9Il9QYXRoXzciIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBjbGFzcz0iY2xzLTciIGQ9Ik0yMC43OSwyNS4zNWMtMi40LS43NS0yLjMtMy4zNS0uNDUtMy44NnMuOS0xLjI1LDEuNzUtMy4yNS0uNDUtMS4zLTEuMzUtMy4xNUE0LjU3LDQuNTcsMCwwLDEsMjAuNTEsMTJhMTIuNCwxMi40LDAsMCwwLTguODIsOS44MWMyLjUxLDIuNTgsNS43NC0uNzIsNi4zLDEuMzVzLS4yLDMuMDUtLjIsMy4wNWE5Ljg1LDkuODUsMCwwLDAtMS4zNSwzLjY1YzAsMSwzLDQuMjMsNC43Nyw2LjE0cS41Ni4xMiwxLjEzLjJhMi44OSwyLjg5LDAsMCwxLDEuMzEtM0MyNS44LDMyLDI2LjIsMjcuNzUsMjYuMiwyNy43NWwtMi0xLjQ1UzIzLjIsMjYuMSwyMC43OSwyNS4zNVoiLz48ZyBpZD0iX0dyb3VwXzIiIGRhdGEtbmFtZT0iJmx0O0dyb3VwJmd0OyI+PHBhdGggaWQ9Il9QYXRoXzgiIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBjbGFzcz0iY2xzLTgiIGQ9Ik0yNi4yLDI3Ljc1bC0yLTEuNDUtLjM1LS4wOFYzM0MyNS44MywzMS43NSwyNi4yLDI3Ljc1LDI2LjIsMjcuNzVaIi8+PHBhdGggaWQ9Il9QYXRoXzkiIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBjbGFzcz0iY2xzLTgiIGQ9Ik0yNy40LDEyYy0uNDYuODQtMS43MywzLjMzLTEuMiw0LjMzLjY1LDEuMi40NS0uNCwyLjEsMHMyLjkuOSw0LC43NSwyLjA1LDIuMjUuNywyLjksMS4yLDUuMzEsMS4yLDUuMzFMMzUuODksMjdBMTIuNCwxMi40LDAsMCwwLDI3LjQsMTJaIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ny45NSA0Ny45NSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmNTcwMzE7fS5jbHMtMntmaWxsOiNkNjViMmI7fS5jbHMtM3tmaWxsOiNmNWZjZmM7fS5jbHMtNHtmaWxsOiNkYWZjZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5Bc3NldCAyMV9pY29uPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSI+PGcgaWQ9Il9Hcm91cF8iIGRhdGEtbmFtZT0iJmx0O0dyb3VwJmd0OyI+PGNpcmNsZSBpZD0iX1BhdGhfIiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgY2xhc3M9ImNscy0xIiBjeD0iMjMuOTgiIGN5PSIyMy45OCIgcj0iMjMuOTgiLz48cGF0aCBpZD0iX1BhdGhfMiIgZGF0YS1uYW1lPSImbHQ7UGF0aCZndDsiIGNsYXNzPSJjbHMtMiIgZD0iTTQ4LDI0di0uMDdMMzQsMTBsLTQuMTgsMi43MXY2LjI2bC41NC41NEwxOCwzMC44NGwtMS4wNS0xLjA1aC00TDEwLDM0LjA2LDIzLjkxLDQ4SDI0QTI0LDI0LDAsMCwwLDQ4LDI0WiIvPjxwYXRoIGlkPSJfUGF0aF8zIiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgY2xhc3M9ImNscy0zIiBkPSJNMTguNzEsMzEuNTFsMTIuOC0xMi44YTQuNjUsNC42NSwwLDAsMCw2LjU5LTQuNTMuNC40LDAsMCwwLS42OC0uMjVsLTIuNSwyLjUtMi44Mi0uNTZMMzEuNTMsMTNsMi41LTIuNWEuNC40LDAsMCwwLS4yNi0uNjgsNC42NCw0LjY0LDAsMCwwLTQuNTEsNi41OWwtMTIuOCwxMi44YTQuNjUsNC42NSwwLDAsMC02LjU5LDQuNTMuNC40LDAsMCwwLC42OC4yNWwyLjUtMi41LDIuODIuNTYuNTYsMi44Mi0yLjUsMi41YS40LjQsMCwwLDAsLjI2LjY4LDQuNjQsNC42NCwwLDAsMCw0LjUxLTYuNTlaIi8+PHBhdGggaWQ9Il9QYXRoXzQiIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBjbGFzcz0iY2xzLTQiIGQ9Ik0zOC4wOSwxNC4xOGEuNC40LDAsMCwwLS42OC0uMjVsLTIuNSwyLjUtMi44Mi0uNTZ2MEwxNS44MiwzMi4wOGgwbC41NiwyLjgyLTIuNSwyLjVhLjQuNCwwLDAsMCwuMjYuNjgsNC42NCw0LjY0LDAsMCwwLDQuNTEtNi41OWwxMi44LTEyLjhhNC42NSw0LjY1LDAsMCwwLDYuNTktNC41M1oiLz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"index"}},[_c('valpo-youtube-splash',{staticClass:"splash",attrs:{"image":_vm.images.ship,"video":_vm.video}},[_c('h1',[_vm._v("Welcome to the adventure")])]),_vm._v(" "),_c('valpo-content',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.images.boat),expression:"images.boat",arg:"background-image"}],staticClass:"about flex-rows",attrs:{"id":"about"}},[_c('h1',[_vm._v("Adventures of the Valparaíso")]),_vm._v(" "),_c('valpo-two-col-section',[_c('p',[_vm._v("\n        We are a ship-based international community passionate about expanding our on-board culture of sustainability and creativity. Since 2013, our foundation has evolved from an artist hub for over 1000 international volunteers in Amsterdam to become a platform for letting the next generations evolve and learn.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        The success of this endeavour has strengthened our belief in a people-centric marketplace and grown our passion for a greater adventure.\n        In 2018 we started to step up our program with young adults and youth workers during our Adventures of the Valparaiso youth exchanges, and worked on new ways to share goods and experiences through the development of the Pirate App.\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n        We are now determined, with support from our homebase in the Netherlands, to equip a larger, seaworthy ship and crew for an international journey of art, music, connection and trade. Our collaborations with sponsors, partners and volunteers are enabling all of us to exchange ideas, skills, stories and goods with local communities worldwide. It is our belief that with each of our individual stories that we are able to tell one, whole story together: the story of the "),_c('strong',[_vm._v("Adventures of the Valparaiso")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',{staticClass:"cta"},[_c('router-link',{attrs:{"to":{ name: 'About', params: { focus: 'about' }}}},[_c('valpo-button',{staticClass:"button magenta animate-bounce-curve-in",attrs:{"label":"Read more about us"}})],1)],1)])],1),_vm._v(" "),_c('valpo-content',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.images.hand),expression:"images.hand",arg:"background-image"}],staticClass:"involved flex-rows fixed-pseudo",attrs:{"id":"involved"}},[_c('h2',[_vm._v("Get involved!")]),_vm._v(" "),_c('valpo-list',{staticClass:"icons flex-center"},_vm._l((_vm.involved),function(item){return _c('valpo-list-item',{key:item.icon},[_c('router-link',{attrs:{"to":{ name: item.link }}},[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.icon),expression:"item.icon"}],attrs:{"alt":item.alt}}),_vm._v(" "),_c('figcaption',[_vm._v("\n              "+_vm._s(item.alt)+"\n            ")])])])],1)}))],1),_vm._v(" "),_c('valpo-content',{staticClass:"future-activities flex-rows",attrs:{"id":"future-activities"}},[_c('h2',{staticClass:"cta"},[_vm._v("Future Activities Abroad")]),_vm._v(" "),_c('valpo-two-col-section',[_c('h4',[_vm._v("A new journey")]),_vm._v(" "),_c('p',[_vm._v("\n        In 2021 our journey to Valparaiso will begin. We’ll set up temporary marketplaces in the U.K., France, Denmark, Spain, Portugal, Morocco, the Canary Islands, Cuba, Puerto Rico, Venezuela, Brazil, Argentina, and, of course, Chile - our final destination. We expect the journey to take a year and a half.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We’ll stock the ship with goods contributed by people and partners. Through a series of sustainability workshops, we’ll show how recycling, upcycling and responsible waste management can change the world.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We will trade donated goods and our skills for three things:\n      ")]),_vm._v(" "),_c('valpo-list',{staticClass:"icons flex-center"},_vm._l((_vm.pirateStuff),function(item){return _c('valpo-list-item',{key:item.icon},[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.icon),expression:"item.icon"}],attrs:{"alt":item.alt}}),_vm._v(" "),_c('figcaption',[_vm._v(_vm._s(item.alt))])])])})),_vm._v(" "),_c('h4',[_vm._v("Stories")]),_vm._v(" "),_c('p',[_vm._v("\n        Stories and experiences are what makes each of us who we are, and sharing them is what bonds us in this journey of combined human consciousness. Stories are recorded, labelled with a serial number, and will be playable on our website, Facebook and mobile app.\n        We will make a documentary of our entire story.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("Goods")]),_vm._v(" "),_c('p',[_vm._v("\n        We will trade our skills and donated goods from our sponsors for sailing necessities and mementos from communities we encounter. All transactions will be recorded in our online database, so that the participants from both our homebase community and abroad can track the journey of their goods across the globe.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("Skills")]),_vm._v(" "),_c('p',[_vm._v("\n        The Valparaiso has always attracted unique people from all over the world with varied skillsets. When we set sail, we will trade the skills of the people we meet with donated goods from our local community.\n      ")])],1)],1),_vm._v(" "),_c('valpo-content',{staticClass:"events flex-rows fixed-pseudo",attrs:{"id":"events"}},[_c('h3',{staticClass:"slogan"},[_vm._v("\n      Upcoming events & Festivals\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Be part of the "),_c('strong',[_vm._v("New Pirate Economy")]),_vm._v(" by participating in our activities.\n    ")]),_vm._v(" "),_c('valpo-events')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Volunteer_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da0c51ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Volunteer_vue__ = __webpack_require__(212);
function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da0c51ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Volunteer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da0c51ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Volunteer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image-light.5934a66.jpg";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image-qr.a7abb8d.jpg";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image-birds.eca02a3.jpg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/valparaiso_projects_boatbike.ae833fd.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/valparaiso_projects_festivals.bd5d956.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/valparaiso_projects_glass.4706dd9.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/valparaiso_projects_grulla.57cee99.jpg";

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"index"}},[_c('valpo-youtube-splash',{staticClass:"splash",attrs:{"image":_vm.images.giuliana,"video":_vm.video}},[_c('h1',[_vm._v("Become a volunteer")])]),_vm._v(" "),_c('valpo-content',{staticClass:"volunteer flex-rows align-center",attrs:{"id":"volunteer"}},[_c('h3',[_vm._v("\n      Join us!\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Looking to be part of an inclusive and creative community? "),_c('br'),_vm._v("\n      Trade your skills and knowledge in exchange for the chance to learn\n      something new from our international crew of volunteers,\n      and get a taste of the pirate life!\n    ")]),_vm._v(" "),_c('valpo-list',{staticClass:"icons flex-center"},_vm._l((_vm.tasks),function(item){return _c('valpo-list-item',{key:item.icon},[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.icon),expression:"item.icon"}],attrs:{"alt":item.alt}}),_vm._v(" "),_c('figcaption',[_vm._v(_vm._s(item.alt))])])])})),_vm._v(" "),_c('h3',{staticClass:"projects",attrs:{"id":"projects"}},[_vm._v("\n      Current projects\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We are determined, with support from our homebase in the Netherlands, to equip a larger and seaworthy ship for aninternational journey of art, sustainability, connection, education, and technological innovation. This all comes together to promote an alternative and people-centric way of trading. One that we call the New Pirate Economy.\n    ")]),_vm._v(" "),_c('valpo-list',{staticClass:"project-items flex-center"},_vm._l((_vm.projects),function(project){return _c('valpo-list-item',{key:project.icon},[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(project.image),expression:"project.image"}],attrs:{"alt":project.title}}),_vm._v(" "),_c('figcaption',[_vm._v("\n            "+_vm._s(project.title)),_c('br'),_vm._v(" "),_c('span',{staticClass:"project-description"},[_vm._v(_vm._s(project.description))])])])])}))],1),_vm._v(" "),_c('valpo-content',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.images.beach),expression:"images.beach",arg:"background-image"}],staticClass:"form flex-rows fixed-pseudo",attrs:{"id":"form"}},[_c('div',{staticClass:"message"},[_c('h3',[_vm._v("Message in a bottle")]),_vm._v(" "),_c('p',[_vm._v("\n          Want to get in touch, have a question or just want to say hi?"),_c('br'),_vm._v("\n          We're always on the lookout for new volunteers and ideas!\n          "),_c('br'),_c('br')]),_vm._v(" "),_c('p',[_c('valpo-button',{staticClass:"button magenta",attrs:{"label":"Send us a message!"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a71209_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(241);
function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13a71209"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a71209_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"splash fixed-pseudo flex-container flex-center",style:(("backgroundImage: url(" + _vm.image + ")"))},[_c('div',{staticClass:"splash-slot"},[_vm._t("default")],2),_vm._v(" "),(_vm.video)?_c('video',{attrs:{"autoplay":"","loop":_vm.video.loop}},[_c('source',{attrs:{"src":_vm.video.src,"type":("video/" + (_vm.video.src.split('.').pop()))}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoTimeline_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6591e6fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoTimeline_vue__ = __webpack_require__(231);
function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6591e6fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoTimeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6591e6fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoTimeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/birth-valparaiso.0dd8677.jpg";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/building.493fc86.jpg";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/moving-to-amsterdam.4b06a42.jpg";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/colaborations2.3472d63.jpg";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/festivals.5ec6aa8.jpg";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/making-the-plan.7a5affc.jpg";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/help-us-find-a-boat.7370e95.jpg";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/freedom-festival.26b648e.jpg";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/france.b1e6748.jpg";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pirate-economy-trade.c8ae195.jpg";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/new-bote.6c687c5.jpg";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pirate_app.88d450e.jpg";

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"timeline",attrs:{"id":"timeline"}},[_c('div',{staticClass:"card-wrapper"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"card"},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"date-box"},[_c('span',{staticClass:"day"},[_vm._v(_vm._s(item.day))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"year"},[_vm._v(_vm._s(item.year))])]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('p',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.image),expression:"item.image"}],attrs:{"alt":item.title}})])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about.2f19902.jpg";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/valparaiso-crew-ulysses.8b044a2.jpg";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dan.2e32387.jpg";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/valparaiso-crew-dave.48722f8.jpg";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/valparaiso-crew-lyvia.8852490.jpg";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/valparaiso-crew-jennie.82ea16f.jpg";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oksanka.b1c6f55.jpg";

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ramiro_Ramirez_crew.86d6be5.jpg";

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"about"}},[_c('valpo-splash',{staticClass:"splash",attrs:{"image":_vm.images.about}},[_c('h1',[_vm._v("Get to know the pirates")])]),_vm._v(" "),_c('valpo-content',{staticClass:"about flex-rows align-center"},[_c('h2',[_vm._v("\n      History of the Valparaiso\n    ")]),_vm._v(" "),_c('valpo-two-col-section',[_c('p',[_vm._v("Valparaiso is a city located on the coastline of Chile, between the Andes and the Pacific Ocean. It was named by the Spanish conquerors when their ships moored upon the shores over five hundred years ago. It was the closest port city that lay along the path to a place which was considered paradise by these sailors after a long enduring journey.\n      ")]),_vm._v(" "),_c('p',[_vm._v("Ulysses, a Dutch traveler, came to the city by coincidence. With his motorcycle left broken on the roadside in Argentina, he resorted to hitchhiking to continue his journey and found his way to Valparaiso.")]),_vm._v(" "),_c('p',[_vm._v("As he travelled through the rough exterior he began to look more into the interior of the city. He fell in love with the bohemian and artistic winds within the city and found a limitless source of inspiration. Like dirty nails and worn hands, the city had its own beauty beneath the surface.")])]),_vm._v(" "),_c('h4',[_vm._v("His compass turned upside down")]),_vm._v(" "),_c('valpo-two-col-section',[_c('p',[_vm._v("Art and culture was very much alive and growing, creating a place of collaboration for creative minds and free thinking people. It was the people that were breathing life into the old streets and dying walls. Valparaiso was referred to as the road to paradise. However it has its own sense of paradise, one that comes from the connections of those living in the city. The sense of satisfaction from a hard day's work or working together to achieve something beautiful is what creates the rich soul of the city.\n      ")]),_vm._v(" "),_c('p',[_vm._v("Adventures of the Valparaiso is a journey along the road to paradise. It is an art studio above the hull of a hundred years old barge that has had more people helping on board than scratches in its paint. The fuel that keeps this ship and its projects going is the inspiration of the old port city it is named after and the sign you see in the window when you first step on board that reads. "),_c('q',[_vm._v("Happiness is the journey not the destination")])])]),_vm._v(" "),_c('h2',[_vm._v("The Timeline")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('valpo-timeline'),_vm._v(" "),_c('section',{staticClass:"crew"},[_c('h2',[_vm._v("The Crew")]),_vm._v(" "),_c('valpo-list',{staticClass:"crew-members flex-center"},_vm._l((_vm.crew),function(member){return _c('valpo-list-item',{key:member.icon},[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(member.image),expression:"member.image"}],attrs:{"alt":member.name}}),_vm._v(" "),_c('figcaption',[_vm._v(_vm._s(member.name)+" "),_c('br'),_c('em',[_vm._v(_vm._s(member.title))])])])])}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Npe_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9b94fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Npe_vue__ = __webpack_require__(246);
function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e9b94fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Npe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9b94fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Npe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/npe.92290a0.jpg";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship.969b6db.jpg";

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"npe"}},[_c('valpo-splash',{staticClass:"splash",attrs:{"image":_vm.images.ship}},[_c('h1',[_vm._v("New Pirate Economy")]),_vm._v(" "),_c('div',[_c('q',{attrs:{"cite":"The Pirate"}},[_vm._v("\n        We are landlubbers because Mother Earth gives us her great resources."),_c('br'),_vm._v("\n        We are pirates because the best ideas don’t know limits.\n      ")])])]),_vm._v(" "),_c('valpo-content',{staticClass:"manifesto flex-rows align-center"},[_c('h2',[_vm._v("The New Pirate Economy Manifesto")]),_vm._v(" "),_c('valpo-two-col-section',[_c('p',[_vm._v("\n        Pirates are typically known for looting, raiding and wrecking wherever they went. But pirates were also the revolutionaries, the progressives, the explorers. They challenged the existing authority, sailed away from mainstream society and created their own alternative culture and socio-economic structure. As pirates of the Valparaíso, we believe that everyone has something to share: culture, experiences, skills and knowledge. We don’t raid, loot or wreck, but collaborate to create change.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Our foundation is about creating innovative and sustainable solutions for challenging the mainstream consumer culture, while providing a bold alternative of thinking about trade and economics. To us, this is the real essence of piracy: the courage to branch out from established societal norms to explore and create progressive and exciting pathways.\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("We are the new pirates!")])])]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"/static/New-Pirate-Economy-manifesto.pdf","target":"_blank"}},[_c('valpo-button',{staticClass:"button cerulean large",attrs:{"label":"Download our manifesto"}})],1)])],1),_vm._v(" "),_c('valpo-content',{staticClass:"npe flex-rows align-center"},[_c('h2',[_vm._v("What is the New Pirate Economy?")]),_vm._v(" "),_c('valpo-two-col-section',[_c('p',[_vm._v("\n        The New Pirate Economy ("),_c('strong',[_vm._v("NPE")]),_vm._v(") is about creating a "),_c('strong',[_vm._v("sustainable marketplace")]),_vm._v(" that inspires genuine connection between people; creative reuse of commodities and a bold alternative to mainstream consumer culture.  It is apparent that future trends are shifting towards a new economic model where money will no longer serve as the sole motivator behind trades.\n      ")]),_c('p',[_vm._v("\n        Which is why we are developing the Pirate App, where participants can trade goods for three things: "),_c('strong',[_vm._v("skills, goods and stories")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        The app will track each transaction using a unique QR code, showing the story behind each individual trade. The story of each trade can be recorded in video, photo or text and attached to the item through the app.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        No matter where you are, the use of blockchain technology will allow us to secure, verify and authenticate this data, to make it possible for people to trade the items again. This way we can start a web of trading that we can trace in lines all over the world.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We are building an economy founded on personal relationships rather than financial worth.\n        "),_c('strong',[_vm._v("Trust is the currency of the future.")])])]),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.images.iconEconomy),expression:"images.iconEconomy"}],staticClass:"economy",attrs:{"alt":"Pirate Economy"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partnership_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c0d785a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partnership_vue__ = __webpack_require__(250);
function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c0d785a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partnership_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c0d785a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partnership_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/partnership.31316f4.jpg";

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"partnership"}},[_c('valpo-splash',{staticClass:"splash",attrs:{"image":_vm.images.partnership}},[_c('h1',[_vm._v("Become our Partner")])]),_vm._v(" "),_c('valpo-content',{staticClass:"partnership flex-rows align-center"},[_c('h1',[_vm._v("Get Involved!")]),_vm._v(" "),_c('valpo-two-col-section',[_c('p',[_vm._v("\n        We have a brave, collective vision. A vision of a sustainable future; of a fair, people-oriented marketplace driven by human connection and the stories that we can only create together.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        By hosting travellers, participating in international festivals, and producing online content to share our stories, we are quickly spreading our message all over the world.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        And now we’re looking for a ship, be it abandoned or donated, to spread our message even further across the globe. We will refit it through creativity, skill and sustainable solutions to transform into unique, renewable community home.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We’re looking for partners who want to be a part of this journey, not just in our practical support stages, but also in the creative initiatives.\n      ")])]),_vm._v(" "),_c('p',{staticClass:"lead-paragraph"},[_vm._v("\n      Please contact our crew if you are interested or would like to learn more.\n    ")]),_vm._v(" "),_c('p',[_c('valpo-button',{staticClass:"button magenta",attrs:{"label":"Send us a message"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c569124_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c569124"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c569124_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoContactForm_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9562a9d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoContactForm_vue__ = __webpack_require__(268);
function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9562a9d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9562a9d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoRecaptcha_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0e513d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoRecaptcha_vue__ = __webpack_require__(257);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValpoRecaptcha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0e513d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValpoRecaptcha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 256 */,
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{attrs:{"sitekey":_vm.sitekey},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}},[_c('button',{staticClass:"button cerulean"},[_vm._v("Confirm your humanity")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"contactForm",attrs:{"id":"contactForm"},on:{"submit":function($event){$event.preventDefault();return _vm.processForm($event)}}},[_c('div',{staticClass:"field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactName),expression:"contactName"}],staticClass:"input",attrs:{"type":"text","name":"name","placeholder":"Name...","autofocus":"","required":""},domProps:{"value":(_vm.contactName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contactName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactEmail),expression:"contactEmail"}],staticClass:"input",attrs:{"type":"email","name":"email","placeholder":"your@email.com","required":""},domProps:{"value":(_vm.contactEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contactEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('p',[_vm._v("Select Subject")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactSubject),expression:"contactSubject"}],staticClass:"contactSubject field",attrs:{"name":"contactSubject","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.contactSubject=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Volunteer Opportunities","lable":"Volunteer Opportunities"}},[_vm._v("Volunteer Opportunities")]),_vm._v(" "),_c('option',{attrs:{"value":"Partnership Opportunities","label":"Partnership Opportunities"}},[_vm._v("Partnership Opportunities")]),_vm._v(" "),_c('option',{attrs:{"value":"General Tips and Questions","label":"General Tips & Questions"}},[_vm._v("General Tips & Questions")])])]),_vm._v(" "),_c('div',{staticClass:"field textarea"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactMessage),expression:"contactMessage"}],attrs:{"name":"contactMessage","rows":"8","cols":"80","placeholder":"Your message...","required":""},domProps:{"value":(_vm.contactMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contactMessage=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"confirmation"},[_c('label',{staticClass:"label"},[_vm._v("Are you Human? What's 3 * 3?")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactHumanCheck),expression:"contactHumanCheck"}],attrs:{"type":"number","name":"humanCheck","value":"","required":""},domProps:{"value":(_vm.contactHumanCheck)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contactHumanCheck=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"button magenta",class:{disabled: !_vm.contactIsHuman},attrs:{"type":"submit"}},[_vm._v("Send Message")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{style:(("backgroundImage: url(" + (_vm.images.beach) + ")")),attrs:{"role":"main","id":"contact"}},[_c('valpo-content',{staticClass:"form",attrs:{"id":"form"}},[_c('h1',[_vm._v("Send us a message in a bottle!")]),_vm._v(" "),_c('section',{staticClass:"message"},[_c('p',[_vm._v("\n        Want to get in touch, have a question or just want to say hi?"),_c('br'),_vm._v("\n        We're always on the lookout for new visions and ideas!\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('p',[_vm._v("Sends us an email to crew@adventuresofthevalparaiso.com")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d96b660_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__ = __webpack_require__(272);
function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d96b660"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d96b660_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"error404"}},[_c('valpo-splash',{staticClass:"splash",attrs:{"video":_vm.video,"image":_vm.images.giuliana}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.images.logo),expression:"images.logo"}],staticClass:"logo",attrs:{"alt":"Adventures of the Valparaiso"}}),_c('br')]),_vm._v(" "),_c('valpo-content',{staticClass:"error404 flex-rows align-center"},[_c('h3',[_vm._v("\n      Error 404 - Treasure not found\n    ")]),_vm._v(" "),_c('valpo-two-col-section',[_c('p',[_vm._v("Valparaiso is a city located on the coastline of Chile, between the Andes and the Pacific Ocean. It was named afterby the Spanish conquerors when their ships moored upon the shores over five hundred years ago. It was the closest port city that lay along the path to a place which was considered paradise by these sailors after a long enduring journey.\n      ")]),_vm._v(" "),_c('p',[_vm._v("Ulysses, a dutch traveler, came to the city by coincidence. With his motorcycle left broken on the roadside in Argentina, he resorted to hitchhiking to continue his journey and found his way to Valparaiso. As he travelled through the rough exterior he began to look more into the interior of the city. He fell in love with the bohemian and artistic winds within the city and found a limitless source of inspiration. Like dirty nails and worn hands, the city had its own beauty beneath the surface.\n      ")])])],1),_vm._v(" "),_c('valpo-content',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.images.beach),expression:"images.beach",arg:"background-image"}],staticClass:"form flex-rows fixed-pseudo",attrs:{"id":"form"}},[_c('div',{staticClass:"message"},[_c('h3',[_vm._v("Message in a bottle")]),_vm._v(" "),_c('p',[_vm._v("\n        Want to get in touch, have a question or just want to say hi?"),_c('br'),_vm._v("\n        We're always on the lookout for new abouts and ideas!\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('p',[_c('valpo-button',{staticClass:"button terracota",attrs:{"label":"Send us an email!"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Construction_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73172df5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Construction_vue__ = __webpack_require__(275);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73172df5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Construction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73172df5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Construction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"fixed-pseudo fullwidth",attrs:{"role":"main","id":"uc"}},[_c('section',{staticClass:"float-center"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.images.logo),expression:"images.logo"}],staticClass:"logo",attrs:{"alt":"Adventures of the Valparaiso"}}),_vm._v(" "),_c('p',[_vm._v("\n        We're currently under construction.\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3164170_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__(290);
function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3164170"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3164170_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship_02.302f1cf.jpg";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tipi.79b4158.jpg";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/festival01.9ddc19f.jpg";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/festival02.69367be.jpg";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/festival03.9ec18f2.jpg";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/festival05.517a594.jpg";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/festival06.511b515.jpg";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/concept_rent_friend.3749c93.jpg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/concept_cranes.a254319.jpg";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/concept_glow_dark.99fad71.jpg";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/concept_dj.a43a1ec.jpg";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/concept_mermaid.f67a0bd.jpg";

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"services"}},[_c('valpo-youtube-splash',{staticClass:"splash",attrs:{"image":_vm.images.giuliana,"video":_vm.video}},[_c('h1',[_vm._v("Book Us")])]),_vm._v(" "),_c('valpo-content',{staticClass:"services-content flex-rows align-center"},[_c('section',{staticClass:"who-we-are"},[_c('div',[_c('h3',[_vm._v("Who are we?")]),_vm._v(" "),_c('p',[_vm._v("\n          The Valparaiso pirates are a ship-based community of artists and travellers who are passionate about sustainability and believe in a people-centric marketplace.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We make installations and concepts that bring this vision to festivals. The tipi and the ship are unique venues that we offer as part of an experience where people can be submerged in a different world and no longer feel like visitors, but part of our community.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          As pirates of the Valparaíso, we believe that everyone has something to share: culture, experiences, skills and knowledge. We don’t raid, loot or wreck, but collaborate to create change.\n        ")])]),_vm._v(" "),_c('div',[_c('h3',[_vm._v("What do we do?")]),_vm._v(" "),_c('p',[_vm._v("\n          Our foundation is about creating innovative and sustainable solutions to challenge mainstream consumer culture, while providing a bold, alternative way of thinking about trade and economics.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          To us, this is the real essence of piracy; the courage to branch out from established societal norms to explore and create progressive and exciting pathways.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Stories and experiences are what make each of us who we are, and sharing them is what brings us together in this journey of combined human consciousness.\n        ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('valpo-content',{staticClass:"spaces"},[_c('h3',[_vm._v("Spaces we offer")]),_vm._v(" "),_vm._l((_vm.spaces),function(space){return _c('valpo-two-col-section',{key:space.title},[_c('div',[_c('h4',[_vm._v(_vm._s(space.title))]),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(space.description))])]),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(space.image),expression:"space.image"}],attrs:{"alt":space.title}})])})],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{staticClass:"projects",attrs:{"id":"projects"}},[_vm._v("\n      Previous Festivals\n    ")]),_vm._v(" "),_c('valpo-list',{staticClass:"project-items flex-center"},_vm._l((_vm.projects),function(project){return _c('valpo-list-item',{key:project.icon},[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(project.image),expression:"project.image"}],attrs:{"alt":project.title}}),_vm._v(" "),_c('figcaption',[_vm._v("\n            "+_vm._s(project.title)),_c('br'),_vm._v(" "),_c('span',{staticClass:"project-description"},[_vm._v(_vm._s(project.description))])])])])})),_vm._v(" "),_c('valpo-content',{staticClass:"concepts"},[_c('h3',[_vm._v("Concepts & Collaborators")]),_vm._v(" "),_vm._l((_vm.concepts),function(concept){return _c('valpo-two-col-section',{key:concept.title},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(concept.image),expression:"concept.image"}],attrs:{"alt":concept.title}}),_vm._v(" "),_c('div',[_c('h4',[_vm._v(_vm._s(concept.title))]),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(concept.description))]),_vm._v(" "),(concept.collaborator)?_c('p',[_vm._v("Collaborator: "),_c('a',{attrs:{"href":concept.link,"target":"_blank"}},[_vm._v(_vm._s(concept.collaborator))])]):_vm._e()])])})],2),_vm._v(" "),_c('section',{staticClass:"brochure"},[_c('p',[_c('a',{attrs:{"href":"/static/valparaiso_community_festival_brochure_2018.pdf","target":"_blank"}},[_c('valpo-button',{staticClass:"button terracota large",attrs:{"label":"Find out more"}})],1)])])],1),_vm._v(" "),_c('valpo-content',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.images.beach),expression:"images.beach",arg:"background-image"}],staticClass:"form flex-rows fixed-pseudo",attrs:{"id":"form"}},[_c('div',{staticClass:"message"},[_c('h3',[_vm._v("Message in a bottle")]),_vm._v(" "),_c('p',[_vm._v("\n          Do you have any questions or queries?\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We’d love to hear from you.\n        ")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"https://docs.google.com/forms/d/e/1FAIpQLSc3qMkBQEV7LfE-jIPq2tv0wXaxtyxGw20b7IrEWHUNLA52Tw/viewform","target":"_blank"}},[_c('valpo-button',{staticClass:"button magenta",attrs:{"label":"Contact us!"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da677db_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(293);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6da677db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da677db_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"privacy-policy"}},[_c('valpo-content',{staticClass:"content"},[_c('h1',[_vm._v("Privacy Policy")]),_vm._v(" "),_c('section',{},[_c('p',[_vm._v("\n        Adventures of the Valparaiso operates the www.adventuresofthevalparaiso.com website, which provides the “SERVICE”.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the Adventures of the Valparaiso website.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Information Collection and Use")]),_vm._v(" "),_c('p',[_vm._v("\n        For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Log Data")]),_vm._v(" "),_c('p',[_vm._v("\n        We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol (\"IP\") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Cookies")]),_vm._v(" "),_c('p',[_vm._v("\n        Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Our website uses these \"cookies\" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Service Providers")]),_vm._v(" "),_c('p',[_vm._v("\n        We may employ third-party companies and individuals due to the following reasons:\n        "),_c('ul',[_c('li',[_vm._v("\n            To facilitate our Service\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            To provide the Service on our behalf\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            To perform Service-related services\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            To assist us in analyzing how our Service is used\n          ")])])]),_vm._v(" "),_c('p',[_vm._v("\n        We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Security")]),_vm._v(" "),_c('p',[_vm._v("\n        We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Links to Other Sites")]),_vm._v(" "),_c('p',[_vm._v("\n        Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Children’s Privacy")]),_vm._v(" "),_c('p',[_vm._v("\n        Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Changes to This Privacy Policy")]),_vm._v(" "),_c('p',[_vm._v("\n        We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Contact Us")]),_vm._v(" "),_c('p',[_vm._v("\n        If you have any questions or suggestions about our Privacy Policy, do not hesitate to "),_c('router-link',{attrs:{"to":{ name: 'Contact', params: {} }}},[_vm._v("contact us")]),_vm._v(".\n      ")],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trainings_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a12588_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trainings_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10a12588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trainings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a12588_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trainings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main","id":"trainings"}},[_c('valpo-splash',{staticClass:"splash",attrs:{"image":_vm.images.trainings}},[_c('h1',[_vm._v("Trainings")])]),_vm._v(" "),_c('valpo-content',{staticClass:"manifesto flex-rows align-center"},[_c('valpo-two-col-section',[_c('p',[_vm._v("\n        In response to the changing world we find ourselves in, it is more important than ever to make sure we have the skills to deal with it.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        While general education provides a good base, it does not always keep up as quickly as it needs to, while climate change is becoming a more imminent threat each day.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        The Adventures of the Valparaiso is in a unique position to provide trainings in line with our partners at the European Commission, Erasmus+ and the European Solidarity Corps, and we are welcoming any new funders who wish to help us reach out to more people.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Our Adventures of the Valparaiso youth exchanges see us work with young adults and youth workers, as well as partner organizations from around Europe to help deliver skills and teachings in a completely different environment.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        From our DIY renewable energy trainings to a focus on non-violent communications and sharing stories to promote peaceful direct action to overcome global and local issues, we also welcome professional trainers who want to pitch ideas and work with us.\n      ")])]),_vm._v(" "),_c('p',[_vm._v("\n      For all enquiries, please email trainings@adventuresofthevalparaiso.com\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyload__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animejs__ = __webpack_require__(313);
// import './axios'
// import './firebase'
// import './vue-touch'



/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_lazyload__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_lazyload__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_lazyload___default.a, {
  preLoad: 1.3,
  attempt: 1,
  observer: true
});

/***/ }),
/* 312 */,
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animejs__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  created: function created() {
    this.$_anime = __WEBPACK_IMPORTED_MODULE_1_animejs___default.a;
  }
});

/***/ }),
/* 314 */,
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polyfills__ = __webpack_require__(321);






__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_3__filters__[key]);
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__helpers__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
    created: function created() {
      this[key] = __WEBPACK_IMPORTED_MODULE_2__helpers__[key];
    }
  });
});

/***/ }),
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["$_until"] = $_until;
/**
 * Async await wrapper for easier error handling
 */
function $_until(promise) {
  return promise.then(function (data) {
    return data;
  }).catch(function (err) {
    return err.response;
  });
}

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["timeAgo"] = timeAgo;
// https://vuejs.org/v2/guide/filters.html

function timeAgo(time) {
  var between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(Math.floor(between / 60), " minute");
  } else if (between < 86400) {
    return pluralize(Math.floor(between / 3600), " hour");
  } else {
    return pluralize(Math.floor(between / 86400), " day");
  }
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + "s";
}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intersection_observer__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_intersection_observer__);


/***/ }),
/* 322 */,
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive("attributes", {
  bind: function bind(el, attributes) {
    attributes.value && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(attributes.value).map(function (attr) {
      if (attr === "class") {
        var c = el.getAttribute(attr);
        c = c === null ? "" : c + " ";
        el.setAttribute(attr, "" + c + attributes.value[attr]);
      } else {
        el.setAttribute(attr, attributes.value[attr]);
      }
    });
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive("link", {
  bind: function bind(el, binding, vnode) {
    el.addEventListener("click", function (event) {
      event.stopImmediatePropagation();
      var _binding$value = binding.value,
          url = _binding$value.url,
          target = _binding$value.target;

      if (url.length && target.length) {
        var open = window.open(url, target);
        open.focus();
      } else if (url.length) {
        // use vue router
        window.location = url;
      }
    });
  }
});

/***/ })
],[98]);


// WEBPACK FOOTER //
// static/js/app.547e725ffe381e2132bc.js